{
	"dialog.ok": "Принять",
	"dialog.cancel": "Отменить",
	"dialog.confirm": "Подтвердить",
	"dialog.close": "Закрыть",
	"dialog.import": "Импорт",
	"dialog.save": "Сохранить",
	"dialog.discard": "Сбросить",
	"dialog.dontshowagain": "Больше не показывать",
	"data.cube": "Куб",
	"data.group": "Группа",
	"data.texture": "Текстура",
	"data.plugin": "Плагин",
	"data.preview": "Предпросмотр",
	"data.toolbar": "Панель инструментов",
	"data.image": "Изображение",
	"keys.ctrl": "Ctrl",
	"keys.shift": "Shiift",
	"keys.alt": "Alt",
	"keys.meta": "Cmd",
	"keys.delete": "Delete",
	"keys.space": "Пробел",
	"keys.leftclick": "ЛКМ",
	"keys.middleclick": "нажать колёсиком",
	"keys.rightclick": "ПКМ",
	"keys.tab": "Tab",
	"keys.backspace": "Backspace",
	"keys.enter": "Enter",
	"keys.escape": "ESC",
	"keys.function": "F%0",
	"keys.numpad": "Numpad %0",
	"keys.caps": "Capslock",
	"keys.menu": "Контекстное меню",
	"keys.left": "Стрелка влево",
	"keys.up": "Стрелка вверх",
	"keys.right": "Стрелка вправо",
	"keys.down": "Стрелка вниз",
	"keys.pageup": "Page up",
	"keys.pagedown": "Page down",
	"keys.plus": "Плюс",
	"keys.comma": "Запятая",
	"keys.point": "Точка",
	"keys.minus": "Минус",
	"keys.cross": "Крестик",
	"keys.end": "End",
	"keys.pos1": "Позиция 1",
	"keys.printscreen": "Print Screen",
	"keys.pause": "Pause",
	"message.rotation_limit.title": "Лимиты вращения",
	"message.rotation_limit.message": "В Minecraft вращения ограничены одной осью и шагом в 22,5 градуса. Вращение по другой оси обнуляет вращение по остальным. Преобразуй модель в \"общую\", если ты создаёшь её для других целей и без ограничений.",
	"message.file_not_found.title": "Файл не найден",
	"message.file_not_found.message": "Blockbench не нашёл запрашиваемый файл. Убедись, что файл сохранён локально, а не в облаке.",
	"message.screenshot.title": "Снимок экрана",
	"message.screenshot.clipboard": "Буфер обмена",
	"message.screenshot.right_click": "Нажми ПКМ или удерживай снимок экрана, чтобы скопировать его",
	"message.invalid_file.title": "Недопустимый файл",
	"message.invalid_file.message": "Не удаётся открыть файл JSON: %0",
	"message.invalid_model.title": "Недопустимый файл модели",
	"message.invalid_model.message": "В файле отсутствуют корректные данные модели.",
	"message.child_model_only.title": "Пустая дочерняя модель",
	"message.child_model_only.message": "Этот файл является дочерним для %0 и не содержит модели.",
	"message.unsaved_textures.title": "Несохранённые текстуры",
	"message.unsaved_textures.message": "В твоей модели имеются несохранённые текстуры. Обязательно сохрани их и помести в нужную папку набора ресурсов.",
	"message.model_clipping.title": "Модель слишком большая",
	"message.model_clipping.message": "Модель содержит %0 элементов, превышающих допустимые размеры блоков в Minecraft. Эта модель не будет работать в игре.",
	"message.loose_texture.title": "Импортирование текстуры",
	"message.loose_texture.message": "Импортированная текстура не находится в наборе ресурсов. Minecraft загружает текстуры только из папки /textures загруженного набора ресурсов.",
	"message.loose_texture.change": "Изменить путь",
	"message.update_res.title": "Разрешение текстуры",
	"message.update_res.message": "Обновить разрешение проекта до разрешения этой текстуры? Нажми ''Отменить'', если разрешение текстуры должно быть выше обычного.",
	"message.update_res.update": "Обновить",
	"message.bedrock_overwrite_error.message": "Blockbench не может объединить эту модель со старым файлом.",
	"message.bedrock_overwrite_error.backup_overwrite": "Создать резервную копию и перезаписать",
	"message.bedrock_overwrite_error.overwrite": "Перезаписать",
	"message.close_warning.message": "Ты хочешь сохранить свою модель?",
	"message.close_warning.web": "Изменения будут потеряны. Ты уверен, что хочешь выйти?",
	"message.default_textures.title": "Текстуры по умолчанию",
	"message.default_textures.message": "Выбери папку /textures в наборе ресурсов по умолчанию",
	"message.default_textures.detail": "Извлеки набор ресурсов по умолчанию из minecraft.jar или скачай его в Интернете. Найди папку /textures и открой её. Blockbench запомнит это местоположение и извлечёт оттуда текстуры, если не найдёт их в текущем наборе ресурсов.",
	"message.default_textures.select": "Выбери папку /textures по умолчанию",
	"message.image_editor.title": "Выбери фоторедактор",
	"message.image_editor.file": "Выбрать файл...",
	"message.image_editor.exe": "Выбери используемый фоторедактор",
	"message.display_skin.title": "Minecraft-скин",
	"message.display_skin.message": "Выбери скин в своих файлах или введи ник игрока",
	"message.display_skin.upload": "Выбрать файл",
	"message.display_skin.reset": "Сбросить",
	"message.invalid_plugin": "Недопустимый файл плагина, посмотри подробности в консоли отладки",
	"message.load_plugin_app": "Разрешить этому плагину изменять локальные файлы? Используй только проверенные плагины.",
	"message.load_plugin_web": "Загрузить этот плагин? Используй только проверенные плагины.",
	"message.preset_no_info": "Шаблон не содержит информации об этом слоте",
	"message.restart_to_update": "Перезапусти Blockbench, чтобы применить изменения",
	"message.save_file": "Сохранено как %0",
	"dialog.project.title": "Проект",
	"dialog.project.name": "Название файла",
	"dialog.project.parent": "Родительская модель",
	"dialog.project.geoname": "Идентификатор модели",
	"dialog.project.ao": "Окружающяя окклюзия",
	"dialog.texture.title": "Текстура",
	"dialog.texture.variable": "Переменная",
	"dialog.texture.namespace": "Пространство имён",
	"dialog.texture.folder": "Папка",
	"dialog.extrude.title": "Экструдировать изображение",
	"dialog.extrude.mode": "Режим сканирования",
	"dialog.extrude.mode.areas": "По областям",
	"dialog.extrude.mode.lines": "По линиям",
	"dialog.extrude.mode.columns": "По столбцам",
	"dialog.extrude.mode.pixels": "По пикселям",
	"dialog.extrude.opacity": "Минимальная непрозрачность",
	"dialog.extrude.scan": "Сканировать и импортировать",
	"dialog.display_preset.title": "Создать шаблон",
	"dialog.display_preset.message": "Выбери слоты, которые нужно сохранить",
	"dialog.display_preset.create": "Создать",
	"dialog.select.title": "Выделение",
	"dialog.select.group": "В выделенной группе",
	"dialog.select.name": "Имя содержит",
	"dialog.select.random": "Случайный шанс (%)",
	"dialog.select.select": "Выделить",
	"dialog.scale.title": "Масштабирование модели",
	"dialog.scale.axis": "Оси",
	"dialog.scale.clipping": "Обрезка модели: Твоя модель слишком велика",
	"dialog.scale.confirm": "Масштабирование",
	"dialog.plugins.title": "Плагины",
	"dialog.plugins.installed": "Установленные",
	"dialog.plugins.available": "Доступные",
	"dialog.plugins.install": "Установить",
	"dialog.plugins.uninstall": "Удалить",
	"dialog.plugins.reload": "Перезагрузить",
	"dialog.plugins.none_installed": "Нет установленных плагинов",
	"dialog.plugins.none_available": "Нет доступных плагинов",
	"dialog.plugins.web_only": "Только для веб-приложения",
	"dialog.plugins.app_only": "Только для настольного приложения",
	"dialog.plugins.author": "от %0",
	"dialog.create_texture.folder": "Папка",
	"dialog.create_texture.resolution": "Разрешение",
	"dialog.input.title": "Ввод",
	"dialog.settings.settings": "Настройки",
	"dialog.settings.keybinds": "Горячие клавиши",
	"dialog.settings.about": "О программе",
	"layout.color.back": "Задний план",
	"layout.color.back.desc": "Фон и поля ввода",
	"layout.color.dark": "Тёмный",
	"layout.color.dark.desc": "Фон рабочей области",
	"layout.color.ui": "Интерфейс",
	"layout.color.ui.desc": "Основной цвет интерфейса",
	"layout.color.bright_ui": "Светлый интерфейс",
	"layout.color.bright_ui.desc": "Контекстное меню и подсказки",
	"layout.color.button": "Кнопка",
	"layout.color.button.desc": "Кнопки и переключатели",
	"layout.color.selected": "Выделенное",
	"layout.color.selected.desc": "Выделенные вкладки и объекты",
	"layout.color.border": "Границы",
	"layout.color.border.desc": "Границы полей ввода и кнопок",
	"layout.color.accent": "Акцент",
	"layout.color.accent.desc": "Ползунки и другие детали",
	"layout.color.grid": "Сетка",
	"layout.color.grid.desc": "Сетка трёхмерной области",
	"layout.color.text": "Текст",
	"layout.color.text.desc": "Обычный текст",
	"layout.color.light": "Подсветка",
	"layout.color.light.desc": "Подсвеченный текст",
	"layout.color.accent_text": "Контрастный текст",
	"layout.color.accent_text.desc": "Текст на светлых элементах",
	"layout.font.main": "Шрифт основного текста",
	"layout.font.headline": "Шрифт заголовка",
	"about.version": "Версия:",
	"settings.category.general": "Основные",
	"settings.category.preview": "Предпросмотр",
	"settings.category.grid": "Сетка",
	"settings.category.edit": "Редактирование",
	"settings.category.snapping": "Привязка к сетке",
	"settings.category.defaults": "По умолчанию",
	"settings.category.dialogs": "Диалоговые окна",
	"settings.category.export": "Экспортирование",
	"settings.language": "Язык",
	"settings.language.desc": "Язык интерфейса. Перезапусти Blockbench, чтобы применить изменения",
	"settings.backup_interval": "Интервал бэкапов",
	"settings.backup_interval.desc": "Интервал бэкапов в минутах",
	"settings.origin_size": "Центр трансформации",
	"settings.origin_size.desc": "Размер центра трансформации",
	"settings.control_size": "Размер гизмо трансформации",
	"settings.control_size.desc": "Размер трёх осевых стрелок трансформации",
	"settings.display_skin": "Minecraft-скин",
	"settings.display_skin.desc": "Референсный скин модели игрока",
	"settings.shading": "Шэйдинг",
	"settings.shading.desc": "Включить шэйдинг модели",
	"settings.base_grid": "Маленькая сетка",
	"settings.base_grid.desc": "Показывать умньшенную сетку с осями",
	"settings.large_grid": "Блочная сетка",
	"settings.large_grid.desc": "Показывать блочную сетку под размер 16×16",
	"settings.full_grid": "Полная большая сетка",
	"settings.full_grid.desc": "Показывать полную блочную сетку 3×3",
	"settings.large_box": "Большая коробка",
	"settings.large_box.desc": "Показывать границу блоков в кубе 3×3×3",
	"settings.display_grid": "Режим отображения",
	"settings.display_grid.desc": "Показывать сетку в режиме отображения",
	"settings.undo_limit": "Шаги отмены",
	"settings.undo_limit.desc": "Количество отменяемых действий",
	"settings.local_move": "Перемещение по относительным осям",
	"settings.local_move.desc": "Перемещать обращённые элементы по направлению их осей при возможности",
	"settings.canvas_unselect": "Снятие выделения при нажатии по фону",
	"settings.canvas_unselect.desc": "Снимать выделение с элементов при нажатии по фону рабочей области",
	"settings.paint_side_restrict": "Ограничить кисть до грани",
	"settings.paint_side_restrict.desc": "Ограничить кисть до окраски текущей грани",
	"settings.autouv": "Авто-UV",
	"settings.autouv.desc": "Применять Авто-UV по умолчанию",
	"settings.create_rename": "Переименовывание новых элементов",
	"settings.create_rename.desc": "При создании элемента или группы переименовывать их",
	"settings.edit_size": "Разрешение сетки",
	"settings.edit_size.desc": "Разрешение сетки, к которой привязываются элементы",
	"settings.shift_size": "Коэффицент Shift",
	"settings.shift_size.desc": "Коэффицент изменения сетки при удерживании Shift",
	"settings.ctrl_size": "Коэффицент Ctrl",
	"settings.ctrl_size.desc": "Коэффицент изменения сетки при удерживании Ctrl",
	"settings.negative_size": "Отрицательный размер",
	"settings.negative_size.desc": "Разрешить использование отрицательных размеров",
	"settings.minifiedout": "Минимизированный экспорт",
	"settings.minifiedout.desc": "Записывать JSON-файл в одну строку",
	"settings.export_groups": "Экспорт групп в модель для Minecraft JE",
	"settings.export_groups.desc": "Сохранять группы в JSON файл модели блока/предмета",
	"settings.credit": "Комментарий создателя",
	"settings.credit.desc": "Прокомментировать экспортированный файл",
	"settings.default_path": "Путь к стандартным Minecraft-текстурам",
	"settings.default_path.desc": "Папка, из которой загружаются стандартные текстуры",
	"settings.image_editor": "Фоторедактор",
	"settings.image_editor.desc": "Графический редактор для изменения текстур",
	"category.navigate": "Навигация",
	"category.tools": "Инструменты",
	"category.file": "Файл",
	"category.blockbench": "Blockbench",
	"category.edit": "Редактирование",
	"category.transform": "Трансформация",
	"category.view": "Вид",
	"category.display": "Настройки отображения",
	"category.textures": "Текстуры",
	"category.misc": "Разное",
	"keybind.preview_select": "Выделить элемент",
	"keybind.preview_rotate": "Вращение вида",
	"keybind.preview_drag": "Перетащить вид",
	"keybind.confirm": "Подтвердить",
	"keybind.cancel": "Отменить",
	"action.slider_inflate": "Раздуть",
	"action.slider_inflate.desc": "Раздуть элементы во все направления без изменений в UV",
	"action.slider_brush_size": "Размер",
	"action.slider_brush_size.desc": "Размер кисти в пикселях",
	"action.slider_brush_opacity": "Непрозрачность",
	"action.slider_brush_opacity.desc": "Непрозрачность кисти от 0 до 255",
	"action.slider_brush_softness": "Мягкость",
	"action.slider_brush_softness.desc": "Мягкость кисти в процентах",
	"action.uv_slider_pos_x": "Горизонтальный сдвиг",
	"action.uv_slider_pos_x.desc": "Сдвинуть UV элементов по-горизонтали",
	"action.uv_slider_pos_y": "Вертикальный сдвиг",
	"action.uv_slider_pos_y.desc": "Сдвинуть UV элементов по-вертикали",
	"action.uv_slider_size_x": "Горизонтальный размер",
	"action.uv_slider_size_x.desc": "Масштабировать UV элементов по-горизонтали",
	"action.uv_slider_size_y": "Вертикальный размер",
	"action.uv_slider_size_y.desc": "Масштабировать UV элементов по-вертикали",
	"action.vertex_snap_mode": "Режим привязки",
	"action.vertex_snap_mode.desc": "Выбрать, перемещает ли инструмент вершинной привязки элементы или изменяет их размер",
	"action.move_tool": "Перемещение",
	"action.move_tool.desc": "Выделить и/или переместить элементы",
	"action.resize_tool": "Изменение размера",
	"action.resize_tool.desc": "Выделить и/или изменить размер элеменов",
	"action.brush_tool": "Кисть",
	"action.brush_tool.desc": "Инструмент для рисования на текстурах",
	"action.vertex_snap_tool": "Вершинная привязка",
	"action.vertex_snap_tool.desc": "Переместить один куб к другому, соединив две вершины",
	"action.swap_tools": "Смена инструмента",
	"action.swap_tools.desc": "Переключиться между инструментом перемещения и изменения размера",
	"action.project_window": "Проект...",
	"action.project_window.desc": "Открыть окно проекта, где можно изменить метаданные модели",
	"action.open_model": "Открытие модели",
	"action.open_model.desc": "Открытие локального файла",
	"action.extrude_texture": "Экструдирование текстуры",
	"action.extrude_texture.desc": "Создание модели посредством растяжения текстуры",
	"action.export_blockmodel": "Экспорт модели блока/предмета",
	"action.export_blockmodel.desc": "Экспортировать модель блока/предмета для Minecraft JE",
	"action.export_optifine_part": "Экспорт части OptiFine-модели",
	"action.export_optifine_part.desc": "Экспортировать отдельную часть модели OptiFine-сущности",
	"action.export_optifine_full": "Экспорт OptiFine JEM",
	"action.export_optifine_full.desc": "Экспортировать целую модель OptiFine-сущности",
	"action.export_obj": "Экспорт OBJ-модели",
	"action.export_obj.desc": "Экспортировать Wavefront OBJ-модель для рендеринга",
	"action.settings_window": "Настройки...",
	"action.settings_window.desc": "Открой диалоговое окно настроек Blockbench.",
	"action.plugins_window": "Плагины...",
	"action.plugins_window.desc": "Открыть хранилище плагинов",
	"action.reset_layout": "Сбросить внешний вид",
	"action.reset_layout.desc": "Сбросить внешний вид к предустановленному",
	"action.load_plugin": "Загрузка плагина из файла",
	"action.load_plugin.desc": "Загрузить плагин, импортировав файл",
	"action.reload_plugins": "Перезагрузить плагины",
	"action.reload_plugins.desc": "Перезагрузить все плагины разработки",
	"action.undo": "Отменить",
	"action.undo.desc": "Отменить последнее действие",
	"action.redo": "Повторить",
	"action.redo.desc": "Повторить последнее действие",
	"action.copy": "Копировать",
	"action.copy.desc": "Копировать выделение, грань или настройки отображения в буфер обмена",
	"action.paste": "Вставить",
	"action.paste.desc": "Вставить выделение, грань или настройки отображения из буфера обмена",
	"action.cut": "Вырезать",
	"action.cut.desc": "Вырезать выделение, грань или настройки отображения",
	"action.add_cube": "Добавление куба",
	"action.add_cube.desc": "Построить примитивный кубический мэш",
	"action.add_group": "Добавление группы",
	"action.add_group.desc": "Добавить новую группу или кость для риггинга",
	"action.outliner_toggle": "Расширенные опции",
	"action.outliner_toggle.desc": "Добавить больше настроек в список элементов",
	"action.duplicate": "Дублировать",
	"action.delete": "Удаление",
	"action.sort_outliner": "Сортировать элементы",
	"action.sort_outliner.desc": "Отсортировать элементы в алфавитном порядке",
	"action.select_window": "Выделить...",
	"action.select_window.desc": "Выделить элементы на основе их свойств",
	"action.invert_selection": "Инверсия выделенной области",
	"action.invert_selection.desc": "Инвертировать текущее выделение элементов",
	"action.select_all": "Выделить всё",
	"action.collapse_groups": "Скрытие группы",
	"action.collapse_groups.desc": "Спрятать содержимое всех групп",
	"action.scale": "Масштабировать...",
	"action.scale.desc": "Пропорционально изменить масштаб всех выделенных элементов",
	"action.toggle_visibility": "Переключить видимость",
	"action.toggle_visibility.desc": "Переключить видимость выделенных элементов",
	"action.toggle_export": "Переключить экспорт",
	"action.toggle_export.desc": "Переключить экспорт выделенных элементов",
	"action.toggle_autouv": "Переключить Авто-UV",
	"action.toggle_autouv.desc": "Переключить настройку Авто-UV выделенных элементов",
	"action.toggle_shade": "Переключить шэйдинг",
	"action.toggle_shade.desc": "Переключить шэйдинг выделенных элементов",
	"action.rename": "Переименовать",
	"action.rename.desc": "Изменить наименование выделенных элементов или групп",
	"action.add_display_preset": "Новый шаблон",
	"action.add_display_preset.desc": "Создать шаблон настроек отображения",
	"action.fullscreen": "Полный экран",
	"action.fullscreen.desc": "Переключить полноэкранный режим",
	"action.zoom_in": "Увеличить",
	"action.zoom_in.desc": "Увеличить масштаб интерфейса",
	"action.zoom_out": "Уменьшить",
	"action.zoom_out.desc": "Уменьшить масштаб интерфейса",
	"action.zoom_reset": "Сбросить масштаб",
	"action.zoom_reset.desc": "Сбросить приближение к стандартным 100%",
	"action.reset_interface": "Сбросить интерфейс",
	"action.reset_interface.desc": "Сбросить размер и позиции интерфейса",
	"action.screenshot_model": "Скриншот модели",
	"action.screenshot_model.desc": "Создать обрезанный скриншот модели с текущего ракурса",
	"action.screenshot_app": "Скриншот приложения",
	"action.screenshot_app.desc": "Сделать скриншот экрана всего приложения",
	"action.import_texture": "Импортирование текстур",
	"action.import_texture.desc": "Импортировать текстуры из файловой системы.",
	"action.create_texture": "Создание текстуры",
	"action.create_texture.desc": "Создать пустую или шаблонную текстуру",
	"action.save_textures": "Сохранить текстуры",
	"action.save_textures.desc": "Сохранить все несохранённые текстуры",
	"action.animated_textures": "Проигрывание текстур",
	"action.animated_textures.desc": "Проигрывать анимацию добавленных текстур",
	"action.origin_to_geometry": "Центрирование оси поворота",
	"action.origin_to_geometry.desc": "Установить центр поворота в центр выбора",
	"action.bone_reset_toggle": "Сбросить кость",
	"action.bone_reset_toggle.desc": "Не показывать элементы родительской модели при взаимодействии с костью",
	"action.reload": "Перезагрузить Blockbench",
	"action.reload.desc": "Перезагрузить Blockbench. Это удалит весь несохранённый прогресс",
	"menu.file": "Файл",
	"menu.edit": "Редактирование",
	"menu.transform": "Трансформация",
	"menu.display": "Отображение",
	"menu.view": "Вид",
	"menu.file.new": "Создать",
	"menu.file.recent": "Недавние",
	"menu.file.import": "Импортировать",
	"menu.file.export": "Экспортировать",
	"menu.transform.rotate": "Повернуть",
	"menu.transform.flip": "Перевернуть",
	"menu.transform.center": "Центрировать",
	"menu.transform.properties": "Свойства",
	"menu.display.preset": "Применить шаблон",
	"menu.display.preset_all": "Применить шаблон везде",
	"menu.display.remove_preset": "Удалить шаблон",
	"menu.view.zoom": "Масштаб интерфейса",
	"menu.view.background": "Фон",
	"menu.view.screenshot": "Снимок экрана",
	"menu.cube.color": "Цвет куба",
	"menu.cube.texture": "Текстура",
	"menu.cube.texture.transparent": "Прозрачная",
	"menu.cube.texture.blank": "Пустая",
	"menu.group.sort": "Сортировать",
	"menu.texture.face": "Применить к грани",
	"menu.texture.file": "Файл",
	"menu.texture.refresh": "Обновить",
	"menu.texture.change": "Заменить файл",
	"menu.texture.folder": "Открыть в папке",
	"menu.texture.edit": "Редактировать",
	"menu.texture.export": "Сохранить как",
	"menu.texture.save": "Сохранить",
	"menu.texture.properties": "Свойства...",
	"menu.preview.background": "Фон",
	"menu.preview.background.load": "Загрузить",
	"menu.preview.background.position": "Позиция",
	"menu.preview.background.lock": "Привязать к камере",
	"menu.preview.screenshot": "Снимок экрана",
	"menu.preview.perspective": "Перспектива",
	"menu.preview.perspective.normal": "Обычная",
	"menu.preview.quadview": "Четыре вида",
	"menu.preview.stop_drag": "Закончить изменение позиции",
	"menu.uv.mapping.rotation": "Вращение",
	"menu.uv.texture": "Текстура",
	"cube.color.light_blue": "Голубой",
	"cube.color.yellow": "Жёлтый",
	"cube.color.orange": "Оранжевый",
	"cube.color.red": "Красный",
	"cube.color.purple": "Фиолетовый",
	"cube.color.blue": "Синий",
	"cube.color.green": "Зелёный",
	"cube.color.lime": "Салатовый",
	"switches.visibility": "Видимость",
	"switches.export": "Экспортировать",
	"switches.autouv": "Авто UV",
	"panel.uv": "UV",
	"panel.display": "Отображение",
	"panel.textures": "Текстуры",
	"panel.outliner": "Элементы",
	"uv_editor.title": "Редактор UV",
	"uv_editor.all_faces": "Все",
	"uv_editor.no_faces": "Нет",
	"face.north": "Север",
	"face.south": "Юг",
	"face.west": "Запад",
	"face.east": "Восток",
	"face.up": "Верх",
	"face.down": "Низ",
	"direction.north": "Север",
	"direction.south": "Юг",
	"direction.west": "Запад",
	"direction.east": "Восток",
	"direction.top": "Верх",
	"direction.bottom": "Низ",
	"display.slot.third_right": "Правая рука от третьего лица",
	"display.slot.third_left": "Левая рука от третьего лица",
	"display.slot.first_right": "Правая рука от первого лица",
	"display.slot.first_left": "Левая рука от первого лица",
	"display.slot.head": "Голова",
	"display.slot.ground": "Пол",
	"display.slot.frame": "Рамка",
	"display.slot.gui": "Интерфейс",
	"display.rotation": "Вращение",
	"display.translation": "Смещение",
	"display.scale": "Масштаб",
	"display.slot": "Слот",
	"display.reference": "Эталонная модель",
	"display.reference.player": "Игрок",
	"display.reference.zombie": "Зомби",
	"display.reference.armor_stand": "Стойка для брони",
	"display.reference.baby_zombie": "Маленький зомби",
	"display.reference.armor_stand_small": "Маленькая стойка для брони",
	"display.reference.monitor": "Обычный вид",
	"display.reference.bow": "Заряженный лук",
	"display.reference.block": "Блок",
	"display.reference.frame": "Рамка",
	"display.reference.inventory_nine": "3x3",
	"display.reference.inventory_full": "Инвентарь",
	"display.reference.hud": "HUD",
	"display.preset.blank_name": "Введи название",
	"display.preset.item": "Предмет",
	"display.preset.block": "Блок",
	"display.preset.handheld": "Оружие",
	"display.preset.rod": "Стержень",
	"dialog.continue": "Продолжить",
	"message.square_textures": "Текстуры должны быть квадратными",
	"message.unsaved_texture.title": "Несохранённая текстура",
	"message.unsaved_texture.message": "Все несохранённые изменения к этой текстуре будут потеряны. Продолжить?",
	"action.vertex_snap_mode.move": "Перемещение",
	"action.vertex_snap_mode.scale": "Масштабировать",
	"action.open_model_folder": "Открытие расположения модели",
	"action.open_model_folder.desc": "Открытие папки с моделью",
	"action.change_textures_folder": "Расположение текстур",
	"action.change_textures_folder.desc": "Изменить папку, в которой сохранены текстуры",
	"menu.texture.particle": "Использовать для частиц",
	"message.update_notification.title": "Доступно обновление",
	"message.update_notification.message": "Доступна новая версия Blockbench. Включи автоматическое обновление в настройках, чтобы обновиться!",
	"message.untextured": "Эта поверхность не имеет текстур",
	"dialog.toolbar_edit.title": "Настроить панель инструментов",
	"keybindings.reset": "Сбросить",
	"keybindings.clear": "Пусто",
	"action.cube_counter": "Статистика модели",
	"action.uv_rotation": "Вращение UV",
	"action.uv_rotation.desc": "Вращение грани UV",
	"action.uv_grid": "Сеть UV",
	"action.uv_grid.desc": "Разрешение сетки, к которой привязывается UV-селектор",
	"action.uv_grid.auto": "Авто",
	"action.uv_maximize": "Максимизировать UV",
	"action.uv_maximize.desc": "Устанавливает UV этой грани на полную текстуру",
	"action.uv_auto": "Авто-UV",
	"action.uv_auto.desc": "Устанавливает UV этой грани на реальный размер грани",
	"action.uv_rel_auto": "Относительные Авто-UV",
	"action.uv_rel_auto.desc": "Устанавливает UV этой грани на позицию и размер текущей грани",
	"action.uv_mirror_x": "Отразить UV по оси X",
	"action.uv_mirror_x.desc": "Отражает UV этой грани по оси X",
	"action.uv_mirror_y": "Отразить UV по оси Y",
	"action.uv_mirror_y.desc": "Отражает UV этой грани по оси Y",
	"action.uv_transparent": "Прозрачная грань",
	"action.uv_transparent.desc": "Удалить UV с этой грани",
	"action.uv_reset": "Сбросить грань",
	"action.uv_reset.desc": "Восстановить эту грань",
	"action.cullface": "Кулфейс",
	"action.cullface.desc": "Выключить прорисовку этой грани, если выбранная сторона перекрыта",
	"action.auto_cullface": "Кулфейс",
	"action.auto_cullface.desc": "Установить кулфейс для этой грани",
	"action.face_tint": "Тонировка",
	"action.face_tint.desc": "Включить тонировку для текущей модели",
	"menu.toolbar.edit": "Настроить панель инструментов",
	"menu.toolbar.reset": "Сбросить панель инструментов",
	"uv_editor.rotated": "Повёрнуто",
	"uv_editor.auto_cull": "Кулфейс к себе",
	"uv_editor.copied": "Грань скопирована",
	"uv_editor.pasted": "Грань вставлена",
	"uv_editor.copied_x": "Скопировано %0 граней",
	"uv_editor.reset": "Сбросить грань",
	"uv_editor.maximized": "Максимизировано",
	"uv_editor.autouv": "Авторазмер",
	"uv_editor.mirrored": "Отражено",
	"uv_editor.to_all": "Применено ко всем граням",
	"uv_editor.transparent": "Сделано прозрачным",
	"uv_editor.cullface_on": "Кулфейс включен",
	"uv_editor.cullface_off": "Кулфейс выключен",
	"uv_editor.tint_on": "Тон включен",
	"uv_editor.tint_off": "Тон выключен",
	"action.uv_apply_all": "Применить ко всем граням",
	"action.uv_apply_all.desc": "Применяет настройки текущей грани всем граням",
	"message.image_editor_missing.title": "Редактор изображений по умолчанию",
	"message.image_editor_missing.message": "Выбери исполняемый файл своего фоторедактора",
	"message.image_editor_missing.detail": "Blockbench не смог найти локальный фоторедактор. Выбери его исполняемый файл вручную.",
	"action.update_autouv": "Обновить Авто-UV",
	"action.update_autouv.desc": "Обновить маппинг Авто-UV у выбранных элементов",
	"category.uv": "UV",
	"status_bar.saved": "Модель сохранена",
	"status_bar.unsaved": "Есть несохранённые изменения",
	"action.move_up": "Сдвиг вверх",
	"action.move_up.desc": "Сместить выбранные элементы вверх относительно камеры",
	"action.move_down": "Сдвиг вниз",
	"action.move_down.desc": "Сместить выбранные элементы вниз относительно камеры",
	"action.move_left": "Сдвиг влево",
	"action.move_left.desc": "Сместить выбранные элементы влево относительно камеры",
	"action.move_right": "Сдвиг вправо",
	"action.move_right.desc": "Сместить выбранные элементы вправо относительно камеры",
	"action.move_forth": "Сдвиг вперёд",
	"action.move_forth.desc": "Сместить выбранные элементы вперед относительно камеры",
	"action.move_back": "Сдвиг назад",
	"action.move_back.desc": "Сместить выбранные элементы назад относительно камеры",
	"layout.color.wireframe": "Каркас",
	"layout.color.wireframe.desc": "Линии при отображении каркаса",
	"layout.color.wireframe_selectable": "Выделяемый каркас",
	"layout.color.wireframe_selectable.desc": "Невыделенные рёбра и вершины активного меша в режиме редактирования",
	"action.add_animation": "Добавление анимации",
	"action.add_animation.desc": "Создать пустую анимацию",
	"action.load_animation_file": "Импортирование анимаций",
	"action.load_animation_file.desc": "Ипортировать локальный файл анимации",
	"action.play_animation": "Проигрывание анимации",
	"action.play_animation.desc": "Предпросмотр выбранной анимации",
	"action.slider_keyframe_time": "Таймкод",
	"action.slider_keyframe_time.desc": "Изменить таймкод для выбранных кадров",
	"timeline.rotation": "Вращение",
	"timeline.position": "Позиция",
	"timeline.scale": "Масштаб",
	"menu.keyframe.quaternion": "Кватернион",
	"panel.animations": "Анимации",
	"panel.keyframe": "Кадр",
	"panel.keyframe.type": "Кадр (%0)",
	"generic.delete": "Удалить",
	"generic.rename": "Переименовать",
	"message.no_animation_selected": "Ты должен выбрать анимацию, чтобы выполнить это",
	"message.no_bone_selected": "Ты должен выбрать кость, чтобы выполнить это",
	"message.duplicate_groups.title": "Дубликат имени кости",
	"message.duplicate_groups.message": "Имя этой кости уже используется. Это может создать проблемы.",
	"action.delete_keyframes": "Удаление кадров",
	"action.delete_keyframes.desc": "Удалить все выбранные кадры",
	"menu.animation": "Анимация",
	"menu.animation.loop": "Цикл",
	"menu.animation.override": "Перезаписать",
	"menu.animation.anim_time_update": "Переменная обновления",
	"message.display_skin_model.title": "Модель скина",
	"message.display_skin_model.message": "Выбери модель для скина",
	"message.display_skin_model.classic": "Классический",
	"message.display_skin_model.slim": "Тонкий",
	"message.bone_material": "Изменить материал кости",
	"action.slider_animation_length": "Длительность анимации",
	"action.slider_animation_length.desc": "Изменить длительность выбранной анимации",
	"panel.variable_placeholders": "Заполнители переменных",
	"panel.variable_placeholders.info": "Перечисли переменные, которые хочешь просмотреть, используя вид имя=значение",
	"status_bar.vertex_distance": "Дистанция: %0",
	"dialog.create_gif.title": "Запись GIF",
	"dialog.create_gif.length": "Длина",
	"dialog.create_gif.fps": "FPS",
	"dialog.create_gif.play": "Воспроизвести анимацию",
	"category.animation": "Анимация",
	"action.record_model_gif": "Запись GIF",
	"action.record_model_gif.desc": "Записать анимированное GIF изображение модели с текущего угла камеры",
	"display.mirror": "Отразить",
	"data.separator": "Разделитель",
	"menu.preview.background.set_position": "Установить позицию",
	"dialog.toolbar_edit.hidden": "Спрятано",
	"action.export_class_entity": "Экспорт сущности для Minecraft JE",
	"action.export_class_entity.desc": "Экспортировать модель сущности Java-классом",
	"settings.seethrough_outline": "Рентгенные контуры",
	"settings.seethrough_outline.desc": "Показывать контуры элементов через объекты",
	"mode.edit": "Редактирование",
	"mode.paint": "Рисование",
	"mode.display": "Предпросмотр",
	"mode.animate": "Анимация",
	"status_bar.recording_gif": "Запись GIF",
	"status_bar.processing_gif": "Обработка GIF",
	"settings.backup_retain": "Время хранения автосохранений",
	"settings.backup_retain.desc": "Установить продолжительность жизни автосохранения в днях",
	"action.rotate_tool": "Вращение",
	"action.rotate_tool.desc": "Выбрать и провернуть элементы",
	"action.fill_tool": "Заполнение",
	"action.fill_tool.desc": "Инструмент для заполнения граней одним цветом",
	"action.eraser": "Ластик",
	"action.eraser.desc": "Инструмент для заполнения прозрачностью на текстурах",
	"action.color_picker": "Выбор цвета",
	"action.color_picker.desc": "Инструмент для выбора цвета пикселей на текстуре",
	"switches.mirror": "Отразить UV",
	"language_name": "Русский",
	"message.plugin_reload": "Перезагружено %0 локальных плагинов",
	"settings.brightness": "Яркость",
	"settings.brightness.desc": "Яркость дисплея (50 по умолчанию)",
	"menu.preview.perspective.reset": "Сбросить камеру",
	"action.fill_mode": "Режим заполнения",
	"action.fill_mode.face": "Грань",
	"action.fill_mode.color": "Цвета",
	"action.toggle_mirror_uv": "Отразить UV",
	"action.toggle_mirror_uv.desc": "Переключить зеркальность UV на оси X выделенных кубов",
	"menu.texture.blank": "Добавить к граням без текстуры",
	"dialog.scale.select_overflow": "Выбрать элементы за границей",
	"action.action_control": "Контроль действий",
	"action.action_control.desc": "Найти и выполнить любое доступное действие",
	"keybindings.recording": "Запись",
	"keybindings.press": "Нажми клавишу или сочетание клавиш в любом месте на экране, чтобы записать горячую клавишу",
	"action.pivot_tool": "Инструмент центра поворота",
	"action.pivot_tool.desc": "Инструмент для изменения центра поворота элементов и костей",
	"action.slider_animation_speed": "Скорость воспроизведения",
	"action.slider_animation_speed.desc": "Скороть воспроизвеления в процентах",
	"action.previous_keyframe": "Предыдущий кадр",
	"action.previous_keyframe.desc": "Перейти к прошлому кадру",
	"action.next_keyframe": "Следующий кадр",
	"action.next_keyframe.desc": "Перейти к следующему кадру",
	"message.outdated_client.title": "Устаревший клиент",
	"message.outdated_client.message": "Пожалуйста, обнови Blockbench до последней версии, чтобы выполнить это действие.",
	"action.export_asset_archive": "Скачивание архива",
	"action.export_asset_archive.desc": "Загрузить архив с моделью и текстурами",
	"action.upload_sketchfab": "Загрузка в Sketchfab...",
	"message.sketchfab.name_or_token": "Введи Sketchfab-токен и имя пользователя",
	"dialog.sketchfab_uploader.title": "Загрузить Sketchfab-модель",
	"dialog.sketchfab_uploader.token": "API-токен",
	"dialog.sketchfab_uploader.about_token": "Этот токен используется для подключения Blockbench к Sketchfab. Ты можешь найти его на 0%",
	"dialog.sketchfab_uploader.name": "Название модели",
	"dialog.sketchfab_uploader.description": "Описание",
	"dialog.sketchfab_uploader.tags": "Тэги",
	"settings.sketchfab_token": "Sketchfab-токен",
	"settings.sketchfab_token.desc": "Токен для авторизации Blockbench для загрузки на Sketchfab-аккаунт",
	"panel.color": "Цвет",
	"data.origin": "Центр поворота",
	"message.sketchfab.success": "Загрузка модели прошла успешно",
	"message.sketchfab.error": "Не удалось загрузить модель на Sketchfab",
	"settings.outliner_colors": "Цвета элементов",
	"settings.outliner_colors.desc": "Показывать цвета в списке элементов",
	"action.upload_sketchfab.desc": "Загрузить модель на Sketchfab",
	"action.element_colors": "Цвета элементов",
	"action.element_colors.desc": "Показывать цвета элементов в списке элементов",
	"texture.error.file": "Файл не найден",
	"texture.error.parent": "Текстура предоставлена родительской моделью",
	"message.recover_backup.title": "Восстановить модель",
	"message.recover_backup.message": "Blockbench был закрыт без сохранения. Восстановить модель?",
	"message.invalid_session.title": "Неверный токен сессии",
	"message.invalid_session.message": "Сессия, к которой ты пытаешься подключиться, истекла или предоставленный токен недействителен.",
	"dialog.create_texture.power": "2ⁿ-разрешение",
	"dialog.create_gif.turn": "Скорость поворота камеры",
	"action.edit_session": "Редактировать сессию...",
	"action.edit_session.desc": "Подключиться к сессии редактирования, чтобы работать с другими пользователями",
	"action.reset_keyframe": "Сбросить кадр",
	"action.reset_keyframe.desc": "Сбросить все значения выбранных кадров",
	"dialog.edit_session.title": "Редактирование сессии",
	"edit_session.username": "Имя пользователя",
	"edit_session.token": "Токен",
	"edit_session.about": "Сессии редактирования позволяют совместно работать над моделями в онлайн-формате. Создай сессию, скопируй токен и отправь его присоединяемому.",
	"edit_session.join": "Присоединиться к сессии",
	"edit_session.create": "Создать сессию",
	"edit_session.quit": "Покинуть сессию",
	"edit_session.joined": "%0 присоединяется к сессии",
	"edit_session.left": "%0 покидает сессию",
	"edit_session.quit_session": "Покидает текущую сессию",
	"edit_session.status": "Статус",
	"edit_session.hosting": "Хост",
	"edit_session.connected": "Подключён к сессии",
	"dialog.sketchfab_uploader.private": "Ограниченный доступ (Pro)",
	"dialog.sketchfab_uploader.password": "Пароль (Pro)",
	"action.uv_select_all": "Выделить всё",
	"action.uv_select_all.desc": "Выделить все грани в диалоге UV",
	"panel.chat": "Чат",
	"edit_session.welcome": "Добро пожаловать в сессию %0!",
	"dialog.yes": "Да",
	"dialog.no": "Нет",
	"generic.remove": "Убрать",
	"generic.download": "Скачать",
	"generic.search": "Поиск",
	"dates.today": "Сегодня",
	"dates.yesterday": "Вчера",
	"dates.this_week": "Этой неделью",
	"dates.weeks_ago": "%0 недель назад",
	"mode.start.new": "Создать",
	"mode.start.recent": "Недавние",
	"format.free": "Общая модель",
	"format.free.desc": "Модель без осевых, размерных и каких-либо иных ограничений для игровых движков (Unity, Godot) и рендеринга",
	"format.java_block": "Модель для Minecraft JE",
	"format.java_block.desc": "Модель для блоков и предметов в Minecraft JE",
	"format.bedrock": "Модель  для Minecraft BE",
	"format.bedrock.desc": "Модель для сущностей и экипированных предметов в Minecraft BE",
	"format.bedrock_old": "Устаревшая модель Bedrock",
	"format.bedrock_old.desc": "Устаревшая модель для версий игры до 1.12 в Minecraft BE",
	"format.modded_entity": "Модовая сущность",
	"format.modded_entity.desc": "Модель модовой сущности для Minecraft JE. Может быть экспортирована в виде .java-файла",
	"format.optifine_entity": "OptiFine-сущность",
	"format.optifine_entity.desc": "Пользовательская модель сущности для OptiFine",
	"keys.mouse": "Кнопка Мыши %0",
	"message.cleared_blank_faces.title": "Пустые грани",
	"message.cleared_blank_faces.message": "Blockbench нашел %0 элементов без текстуры. Удалить эти элементы?",
	"message.wireframe.enabled": "Каркас включен",
	"message.wireframe.disabled": "Каркас выключен",
	"dialog.convert_project.title": "Конвертировать проект",
	"dialog.create_texture.double_use": "Многократное использование текстур",
	"dialog.model_stats.title": "Статистика модели",
	"dialog.model_stats.cubes": "Кубы",
	"dialog.model_stats.locators": "Локаторы",
	"dialog.model_stats.groups": "Группы",
	"dialog.model_stats.vertices": "Вершины",
	"dialog.model_stats.faces": "Грани",
	"settings.username": "Имя пользователя",
	"settings.username.desc": "Имя пользователя в сессиях редактирования",
	"settings.painting_grid": "Сетка рисования",
	"settings.painting_grid.desc": "Показывать сетку рисования на элементах с текстурой в режиме рисования",
	"action.convert_project": "Конвертация проекта",
	"action.convert_project.desc": "Конвертировать текущий проект в проект для другого формата модели",
	"action.close_project": "Закрытие проекта",
	"action.close_project.desc": "Закрытие текущего проекта",
	"action.export_bedrock": "Экспорт геометрии Minecraft BE",
	"action.export_bedrock.desc": "Экспортировать модель как файл геометрии Minecraft BE",
	"action.save_project": "Сохранить проект",
	"action.save_project.desc": "Сохранить текущую модель как файл проекта",
	"action.save_project_as": "Сохранить проект как",
	"action.save_project_as.desc": "Сохранить текущую модель как файл проекта в новом месте",
	"action.export_over": "Сохранить модель",
	"action.export_over.desc": "Сохранить модель, текстуры и анимации перезаписывая файлы",
	"action.add_locator": "Добавление локатора",
	"action.add_locator.desc": "Добавить новый локатор для контроля позиции частиц, поводков и т.д.",
	"action.uv_turn_mapping": "Повернуть преобразование",
	"action.uv_turn_mapping.desc": "Повернуть UV-преобразование на 90°",
	"action.remove_blank_faces": "Удалить пустые грани",
	"action.remove_blank_faces.desc": "Удалить все грани элементов без текстуры",
	"web.download_app": "Скачать приложение",
	"uv_editor.turned": "Преоброзование овёрнуто",
	"display.reference.crossbow": "Заряженный арбалет",
	"dialog.settings.search_results": "Результаты поиска",
	"settings.animation_snap": "Привязка анимаций",
	"settings.animation_snap.desc": "Интервал привязки по умолчанию для ключевых кадров в анимационной шкале времени, измеряемый в FPS. Этот параметр можно изменить для каждой анимации. Значение по умолчанию — 24.",
	"action.import_optifine_part": "Импортирование части OptiFine-модели",
	"action.import_optifine_part.desc": "Импортировать часть модели сущности OptiFine",
	"data.locator": "Локатор",
	"mode.start.no_recents": "Нет открытых моделей",
	"panel.element": "Элемент",
	"panel.element.position": "Позиция",
	"panel.element.size": "Размер",
	"panel.element.origin": "Центральная точка",
	"panel.element.rotation": "Вращение",
	"message.canvas_limit_error.title": "Ошибка ограничения рабочей области",
	"message.canvas_limit_error.message": "Действие не может быть выполнено правильно, поскольку формат ограничивает размеры рабочей области до 48 единиц. Смести центр поворота, чтобы исправить это.",
	"data.effect": "Эффект",
	"generic.name": "Имя",
	"settings.recent_projects": "Недавние модели",
	"settings.recent_projects.desc": "Громкость",
	"settings.volume": "Громкость",
	"settings.volume.desc": "Регулятор громкости звуковых эффектов в анимации",
	"action.clear_timeline": "Очистка шкалы времени",
	"action.clear_timeline.desc": "Удалить все дорожки анимации из временной шкалы",
	"action.select_effect_animator": "Эффекты анимации",
	"action.select_effect_animator.desc": "Открыть временную шкалу для добавления звуковых эффектов и частиц",
	"action.timeline_focus": "Канал",
	"action.timeline_focus.desc": "Выбрать каналы анимации для отображения на временной шкале",
	"timeline.particle": "Частица",
	"timeline.sound": "Звук",
	"timeline.effects": "Эффекты",
	"data.format": "Формат",
	"format.optifine_part": "Раздел Optifine",
	"format.optifine_part.desc": "JPM для моделей сущности OptiFine",
	"action.reverse_keyframes": "Реверс ключевых кадров",
	"action.reverse_keyframes.desc": "Реверс ключевых кадров в обратном порядке",
	"generic.help": "Справка",
	"message.removed_faces": "Удалено %0 граней",
	"dialog.sketchfab_uploader.draft": "Черновик",
	"action.slider_pos": "Перемещено %0",
	"action.slider_pos.desc": "Перемещение элементов по оси %0",
	"action.slider_size": "Размер %0",
	"action.slider_size.desc": "Изменить размер элементов на оси %0",
	"action.slider_rotation": "Поворот %0",
	"action.slider_rotation.desc": "Повернуть элементы на оси %0",
	"action.slider_origin": "Ось вращения %0",
	"action.slider_origin.desc": "Переместить ось вращения на оси %0",
	"action.rotate_cw": "Поворот %0 +90",
	"action.rotate_cw.desc": "Повернуть выбранные элементы на 90° на оси %0",
	"action.rotate_ccw": "Поворот %0 -90",
	"action.rotate_ccw.desc": "Повернуть выбранные элементы на -90° на оси %0",
	"action.flip": "Переворот %0",
	"action.flip.desc": "Перевернуть выбранные элементы по оси %0",
	"action.center": "Центр %0",
	"action.center.desc": "Центр выбранных элементов по оси %0",
	"action.bring_up_all_animations": "Сворачивание анимаций",
	"panel.bone": "Кость",
	"data.color": "Цвет",
	"generic.export": "Экспортировать",
	"generic.none": "Ничего",
	"status_bar.recording": "Шкала записи",
	"message.add_to_palette": "Добавлено в палитру",
	"message.size_modifiers": "Удерживай Ctrl или Shift для уменьшения коэффицента трансформации",
	"message.timelapse_start": "Ускоренная съемка началась",
	"message.timelapse_stop": "Ускоренная съемка закончилась",
	"message.import_palette.replace_palette": "Заменить старую палитру",
	"message.import_palette.threshold": "Граница соединения",
	"dialog.timelapse.interval": "Интервал (с)",
	"dialog.timelapse.source": "Источник",
	"dialog.timelapse.source.interface": "Интерфейс",
	"dialog.timelapse.source.locked": "Заблокированный угол",
	"dialog.timelapse.destination": "Папка назначения",
	"layout.color.checkerboard": "Клетка",
	"layout.color.checkerboard.desc": "Фон рабочей области и редактора UV",
	"layout.font.code": "Шрифт кода",
	"layout.css": "Пользовательский CSS",
	"settings.category.paint": "Рисование",
	"settings.deactivate_size_limit": "Выключить лимит размера",
	"settings.deactivate_size_limit.desc": "Выключить лимит размера для определенных форматов. Предупреждение: Это может вызвать ошибки с моделями.",
	"settings.brush_opacity_modifier": "Модификатор непрозрачности кисти",
	"settings.brush_opacity_modifier.desc": "Модифицировать непрозрачность кисти при использовании стилуса",
	"settings.brush_size_modifier": "Модификатор размера кисти",
	"settings.brush_size_modifier.desc": "Модифицировать размер кисти при использовании стилуса",
	"settings.brush_modifier.pressure": "Давление",
	"settings.brush_modifier.tilt": "Наклон",
	"category.color": "Цвет",
	"action.import_theme": "Импортирование темы",
	"action.export_theme": "Экспорт темы",
	"action.export_theme.desc": "Создать файл темы на основе текущих настроек",
	"action.slider_color_h": "Оттенок",
	"action.slider_color_s": "Насыщение",
	"action.slider_color_v": "Значение",
	"action.add_to_palette": "Добавление в палитру",
	"action.add_to_palette.desc": "Добавить выбранные цвета в палитру",
	"action.import_palette": "Импортирование палитры",
	"action.import_palette.desc": "Импорт .bbpalette файл",
	"action.export_palette": "Экспорт палитры",
	"action.export_palette.desc": "Экспорт палитры в файл .GPL",
	"action.generate_palette": "Генерация палитры",
	"action.generate_palette.desc": "Сгенерировать палитру из текстуры",
	"action.sort_palette": "Сортировка палитры",
	"action.sort_palette.desc": "Сортировать цвета на палитре по цвету и яркости",
	"action.timelapse": "Временная шкала",
	"action.timelapse.desc": "Записать процесс создания модели",
	"action.add_keyframe": "Добавление ключевого кадра",
	"action.add_keyframe.desc": "Добавить ключевой кадр в выбранный аниматор",
	"action.bring_up_all_animations.desc": "Перенос всех модифицированных анимаций на временную шкалу",
	"timeline.timeline": "Инструкции",
	"menu.palette.load.default": "Стандарт",
	"generic.import": "Импортировать",
	"settings.brush_modifier.none": "Ничего",
	"action.export_entity": "Экспорт сущности Minecraft BE",
	"action.export_entity.desc": "Добавить выбранную модель как сущность в файл mobs.json",
	"settings.highlight_cubes": "Выделить элементы",
	"settings.highlight_cubes.desc": "Выделить элементов в момент наведения на них курсора мыши",
	"action.add_marker": "Установка маркёра",
	"action.add_marker.desc": "Установить маркёр на шкале времени",
	"timeline.pre_effect_script": "Скрипт",
	"format.skin": "Скин",
	"format.skin.desc": "Редактирование скинов игроков и сущностей",
	"message.sketchfab.setup_guide": "Хочешь узнать, как настраивать модели в Sketchfab? Читать %0",
	"dialog.skin.title": "Создать скин",
	"dialog.skin.model": "Модель",
	"action.toggle_skin_layer": "Переключить слой скина",
	"action.toggle_skin_layer.desc": "Переключить слои шляпы и одежды",
	"action.gui_light": "Светлый интерфейс",
	"action.gui_light.desc": "Выбрать способ освещения предмета в инвентаре",
	"action.gui_light.side": "Боковой свет",
	"action.gui_light.front": "Передний свет",
	"action.move_keyframe_back": "Сдвиг кадров назад",
	"action.move_keyframe_forth": "Сдвиг кадров вперед",
	"menu.help": "Помощь",
	"menu.help.discord": "Сервер в Discord",
	"menu.help.report_issue": "Сообщить о проблеме",
	"menu.help.plugin_documentation": "Документация Plugin API",
	"menu.help.search_action": "Найти и выполнить действие",
	"menu.help.donate": "Пожертвовать",
	"menu.help.about": "О программе...",
	"menu.preview.background.clipboard": "Загрузить из буфера обмена",
	"dialog.ignore": "Игнорировать",
	"generic.unset": "Не выбрано",
	"message.invalid_builtin_parent.title": "Неверный встроенный родитель",
	"message.invalid_builtin_parent.message": "Ссылка на неправильную родительскую модель '%0' была удалена для экспорта правильной модели",
	"dialog.resize_texture.fill": "Заполнить с помощью",
	"dialog.resize_texture.fill.transparent": "Прозрачный",
	"dialog.resize_texture.fill.color": "Цвет",
	"dialog.resize_texture.fill.repeat": "Повторить",
	"dialog.scale.element_pivot": "Центр элемента",
	"dialog.scale.selection_center": "Центр выбора",
	"dialog.create_gif.length_mode": "Режим длины",
	"dialog.create_gif.length_mode.seconds": "Секунды",
	"dialog.create_gif.length_mode.frames": "Кадры",
	"dialog.create_gif.length_mode.animation": "Длина анимации",
	"dialog.create_gif.length_mode.turntable": "Переключаемое вращение",
	"dialog.save_angle.projection": "Проэкция",
	"dialog.save_angle.projection.perspective": "Перспектива",
	"dialog.save_angle.projection.orthographic": "Ортография",
	"dialog.sketchfab_uploader.animations": "Анимации",
	"dialog.settings.theme": "Тема",
	"settings.category.interface": "Интерфейс",
	"settings.preview_checkerboard": "Шахматная доска в предпросмотре",
	"settings.preview_checkerboard.desc": "Переключить отображение шахматной доски на фоне предварительного просмотра",
	"settings.uv_checkerboard": "Шахматная доска UV-редактора",
	"settings.uv_checkerboard.desc": "Переключить отображение шахматной доски на фоне UV-редактора",
	"category.paint": "Рисование",
	"action.fill_mode.color_connected": "Соединённые цвета",
	"action.draw_shape_type": "Тип фигуры",
	"action.draw_shape_type.rectangle": "Четырёхугольник",
	"action.draw_shape_type.rectangle_h": "Прямоугольник (полый)",
	"action.draw_shape_type.ellipse": "Эллипс",
	"action.draw_shape_type.ellipse_h": "Эллипс (полый)",
	"action.draw_shape_type.line": "Линия",
	"action.mirror_painting": "Зеркальное рисование",
	"action.mirror_painting.description": "Зеркально отразите свои мазки текстуры на другой стороне модели",
	"action.lock_alpha": "Блокировка альфа-канала",
	"action.lock_alpha.description": "Заблокировать настройки непрозрачности всех пикселей",
	"action.draw_shape_tool": "Фигура",
	"action.draw_shape_tool.desc": "Инструмент для рисования простых фигур",
	"action.export_gltf": "Экспорт gLTF-модели",
	"action.export_gltf.desc": "Экспортировать модель и анимации как glTF-файл для использования в других программах",
	"action.transform_space": "Способ трансформация",
	"action.transform_space.desc": "Метод трансформации элементов относительно собственной, родительской или глобальной осей",
	"action.transform_space.global": "Глобальный",
	"action.transform_space.local": "Локальный",
	"action.toggle_camera_projection": "Включить проекцию камеры",
	"action.toggle_camera_projection.desc": "Переключить проекцию камеры между перспективой и ортографией",
	"action.load_camera_angle": "Угол камеры: %0",
	"action.load_camera_angle.desc": "Загрузить ракурс камеры в %0",
	"action.slider_face_tint": "Индекс оттенка",
	"action.slider_face_tint.desc": "Поставить индекс оттенка на эту грань. -1 означает непоставлено",
	"menu.help.quickstart": "Путеводитель Blockbench",
	"menu.help.developer": "Фунции разработчика",
	"menu.help.developer.dev_tools": "Открыть инструменты разработчика",
	"menu.help.developer.reset_storage": "Сброс до заводских настроек",
	"menu.help.developer.reset_storage.confirm": "Ты уверен, что хочешь вернуть Blockbench до заводских параметров? Это сбросит все пользовательские настройки, горячие клавиши и плагины.",
	"menu.help.developer.cache_reload": "Перезагрузить кэш",
	"menu.preview.orthographic": "Ортография",
	"menu.preview.save_angle": "Сохранить угол...",
	"menu.preview.angle": "Углы",
	"menu.preview.angle.initial": "Инициальный угол",
	"menu.preview.maximize": "Увеличить до конца",
	"uv_editor.copy_selection": "Скопировать выбор",
	"uv_editor.paste_selection": "Вставить выделенный обьект",
	"uv_editor.copy_paste_tool.place": "Поставить",
	"uv_editor.copy_paste_tool.mirror_x": "Отзеркалеть по X",
	"uv_editor.copy_paste_tool.mirror_y": "Отзеркалить по Y",
	"uv_editor.copy_paste_tool.rotate": "Повернуть на 90 градусов",
	"dialog.project.modded_entity_version": "Экспортировать версию",
	"dialog.save_angle.position": "Позиция камеры",
	"dialog.save_angle.target": "Точка Фокуса",
	"dialog.skin.pose": "Поза",
	"layout.color.frame": "Окно",
	"layout.color.frame.desc": "Рамка и заголовок окна",
	"settings.large_grid_size": "Размер сетки блока",
	"settings.large_grid_size.desc": "Размер сетки блока",
	"action.load_plugin_from_url": "Загрузка плагина по ссылке",
	"action.load_plugin_from_url.desc": "Загрузить плагин через сервер, уточняя ссылку",
	"action.cube_counter.desc": "Показывает номер кубов и другую статистику",
	"action.unlock_everything": "Разблокировать всё",
	"action.unlock_everything.desc": "Разблокировать все группы и элементы в аутлайнере",
	"action.load_palette": "Загрузка палитры",
	"action.load_palette.desc": "Загрузить одну из встроенных предварительных палитр",
	"action.toggle_locked": "Включить блокировку",
	"action.toggle_locked.desc": "Переключить будут ли выбранные элементы заблокированы",
	"action.apply_display_preset": "Применение шаблона",
	"action.apply_display_preset.desc": "Применить обычный или свой предварительный набор настроек",
	"action.apply_display_preset.here": "Применение к этому слоту",
	"action.apply_display_preset.everywhere": "Применение ко всем слотам",
	"action.resolve_keyframe_expressions": "Вычислить кадры",
	"action.resolve_keyframe_expressions.desc": "Вычисляет математические примеры выбранных кадров",
	"action.fold_all_animations": "Сложение всех анимаций",
	"menu.palette.load.empty": "Чисто",
	"switches.lock": "Заблокировать",
	"settings.render_sides": "Стороны рендера",
	"settings.render_sides.desc": "Выбери, какая часть ребра будет отрендерена",
	"settings.render_sides.auto": "Авто",
	"settings.render_sides.front": "Снаружи",
	"settings.render_sides.double": "Внутри и снаружи",
	"generic.enable": "Включить",
	"generic.disable": "Выключить",
	"generic.redacted": "Изменено",
	"dialog.select_texture.import_all": "Импорт все",
	"dialog.skin.layer_template": "Слой текстуры",
	"about.version.up_to_date": "Актуальная версия",
	"about.version.update_available": "Доступно обновление %0",
	"settings.category.application": "Приложение",
	"settings.streamer_mode": "Режим стримера",
	"settings.streamer_mode.desc": "Скрывает определённую информацию, такую как список недавних моделей и личные данные",
	"settings.automatic_updates": "Автоматические обновления",
	"settings.automatic_updates.desc": "Автоматически загружать новые версии и поддерживать Blockbench в актуальном состоянии",
	"action.rotation_space": "Вращающее пространство",
	"action.focus_on_selection": "Центрирование камеры на выделении",
	"action.focus_on_selection.desc": "Выровнять камеру по центру данного выделения",
	"action.jump_to_timeline_start": "В начало анимации",
	"action.jump_to_timeline_end": "В конец анимации",
	"menu.help.updating": "Обновление (%0%)",
	"menu.help.update_failed": "Ошибка обновления",
	"menu.animation.loop.once": "Проиграть один раз",
	"menu.animation.loop.hold": "Остановить на последнем кадре",
	"menu.animation.loop.loop": "Цикл",
	"interface.streamer_mode_on": "Режим стримера включён",
	"generic.reset": "Сбросить",
	"generic.restore": "Восстановить",
	"keys.mousewheel": "Колесо мыши",
	"message.delete_animation.title": "Удалить анимацию",
	"message.delete_animation.message": "Анимация удалена из Blockbench. Удалить анимацию из файла, в котором она была сохранена?",
	"message.no_animation_to_import": "Нет анимаций для импорта",
	"dialog.material_instances.title": "Экземпляры материалов",
	"dialog.animation_import.title": "Выбери анимации для импорта",
	"dialog.create_texture.padding": "Отступ",
	"settings.fov": "FOV",
	"settings.fov.desc": "Поле зрения камеры. Значение по умолчанию — 45°",
	"settings.minify_bbmodel": "Уменьшенные файлы проекта",
	"settings.minify_bbmodel.desc": "Записывать файлы .bbmodel в одну уменьшенную строчку",
	"action.edit_material_instances": "Изменение образцов материалов",
	"action.edit_material_instances.desc": "Изменить экземпляры материалов для геометрии блоков Minecraft BE",
	"action.save_all_animations": "Сохранить все анимации",
	"action.save_all_animations.desc": "Сохранить все выделенные анимации",
	"action.keyframe_interpolation": "Интерполяция",
	"action.keyframe_interpolation.desc": "Выбрать режим интерполяции для кадров",
	"action.keyframe_interpolation.linear": "Линейный",
	"action.keyframe_interpolation.catmullrom": "Сглаженный",
	"action.timeline_focus.hide_empty": "Спрятать пустые каналы",
	"menu.file.preferences": "Предпочтения",
	"menu.animation.blend_weight": "Сила смешивания",
	"menu.animation.save": "Сохранить",
	"menu.animation.properties": "Характеристики",
	"menu.animation.file": "Файл",
	"menu.animation.snapping": "Привязка",
	"menu.animation.open_location": "Открыть расположение файла",
	"panel.keyframe.add_data_point": "Добавить точку данных кадра",
	"panel.keyframe.remove_data_point": "Удалить точку данных",
	"panel.keyframe.pre": "До",
	"panel.keyframe.post": "После",
	"generic.all": "Всё",
	"message.small_face_dimensions.title": "Неподходящие размеры лица",
	"message.small_face_dimensions.message": "Выделение содержит лица меньше 1 юнита в каком-либо направлении. Система отображения Box UV считает лица меньше 1 юнита, как 0 пикселей в ширину. Поэтому текстура на этих частях может отображаться неверно.",
	"message.small_face_dimensions.face_uv": "Текущий формат поддерживает UV по лицам, которые могут работать с небольшими размерами. Нажми на элементы правой кнопкой мыши и поменяй \"UV Mode\" на \"Per-face UV\".",
	"dialog.plugins.outdated_client": "Требует более новую версию Blockbench",
	"dialog.plugins.outdated_plugin": "Плагин устарел и более не работает с этой версией Blockbench",
	"settings.motion_trails": "Пути движения",
	"settings.motion_trails.desc": "Показывает пути движения в редакторе анимаций",
	"settings.antialiasing": "Сглаживание",
	"settings.antialiasing.desc": "Переключить сглаживание в превью. Требуется перезапуск Blockbench",
	"action.timeline_frame_back": "Перейти на кадр назад",
	"action.timeline_frame_forth": "Перейти на кадр вперед",
	"panel.bone.ik": "Инверсная кинематика",
	"settings.particle_tick_rate": "Частота тактов частиц",
	"settings.particle_tick_rate.desc": "Частота для эффектов партиклей в тактах в секунду. Значение по умолчанию — 30",
	"action.lock_motion_trail": "Блокировка пути движения",
	"action.lock_motion_trail.desc": "Заблокировать пути движения для выбраных групп",
	"menu.animation_file.unload": "Скачать файл с анимацией",
	"data.null_object": "Нулевой объект",
	"status_bar.toggle_sidebar": "Включить боковую панель",
	"message.load_plugin_failed.title": "Не удалось загрузить плагин",
	"message.load_plugin_failed.message": "Убедитесь, что имя файла плагина соответствует ID плагина `%0`, как указано в Plugin.register().",
	"dialog.project.uv_mode": "Режим UV",
	"dialog.project.uv_mode.box_uv": "UV-коробка",
	"dialog.project.uv_mode.face_uv": "UV по лицам",
	"dialog.project.texture_size": "Размер текстур",
	"dialog.animation_export.title": "Выбрать анимации для экспорта",
	"dialog.create_texture.rearrange_uv": "Перестроить UV",
	"layout.color.subtle_text": "Тонкий Текст",
	"layout.color.subtle_text.desc": "Цвет второстепенного текста с меньшим контрастом",
	"settings.interface_scale": "Масштаб интерфейса",
	"settings.interface_scale.desc": "Размер всего интерфейса Blockbench",
	"settings.background_rendering": "Рендер фона",
	"settings.background_rendering.desc": "Обновлять предпросмотр, когда окно свернуто",
	"settings.ctrl_shift_size": "Коэффицент Ctrl+Shift",
	"settings.ctrl_shift_size.desc": "Разрешение сетки при зажатии контрола и шифта",
	"settings.hardware_acceleration": "Аппаратное ускорение",
	"settings.hardware_acceleration.desc": "Рендерить модели при помощи видеокарты. Перезапусти Blockbench, чтобы применить изменения.",
	"action.explode_skin_model": "Разделить модель игрока",
	"action.explode_skin_model.desc": "Разъединяет части тела для просмотра закрытых участков модели",
	"action.export_minecraft_skin": "Экспорт Minecraft-скина",
	"action.export_minecraft_skin.desc": "Экспортировать Minecraft-скин в формате .png",
	"action.add_null_object": "Добавление нулевого объекта",
	"action.add_null_object.desc": "Добавить новый нулевой объект",
	"action.animated_texture_frame": "Кадр анимированной текстуры",
	"action.animated_texture_frame.desc": "Установить текущий кадр анимированной текстуры",
	"action.export_animation_file": "Экспорт анимаций...",
	"action.export_animation_file.desc": "Экспортировать выделенные анимации в новый файл",
	"action.timeline_graph_editor": "Переключить Редактор Графиков",
	"action.timeline_graph_editor.desc": "Переключение временной шкалы между представлением графического редактора и редактора ключей",
	"menu.file.recent.clear": "Очистить последние файлы",
	"switches.shade": "Тень",
	"generic.share": "Поделиться",
	"dates.minute": "%0 минут",
	"dates.minutes": "%0 минут",
	"dates.hour": "%0 часов",
	"dates.hours": "%0 часов",
	"dates.day": "%0 дней",
	"dates.days": "%0 дней",
	"dates.week": "%0 неделя",
	"dates.weeks": "%0 недель",
	"dates.year": "%0 лет",
	"dates.years": "%0 лет",
	"message.installed_plugin": "Плагин %0 успешно загружен",
	"message.installed_plugin_fail": "Не удалось загрузить плагин %0",
	"dialog.share_model.title": "Поделиться моделью",
	"dialog.share_model.expire_time": "Время истекания",
	"dialog.share_model.failed": "Не удалось загрузить модель",
	"action.import_java_block_model": "Добавление модели блока/предмета для Minecraft JE",
	"action.import_java_block_model.desc": "Добавить модель для Minecraft JE из файла .json в текущую модель",
	"action.share_model": "Поделиться...",
	"action.share_model.desc": "Сгенерировать короткую ссылку чтобы поделиться моделью",
	"action.import_project": "Импортирование проекта",
	"action.import_project.desc": "Импортировать другой проект из файла .bbmodel в текущий проект",
	"dialog.toolbar_edit.hidden_tools": "Некоторые инструменты могут быть скрыты из-за невозможности использования в текущем режиме, формате или ситуации.",
	"settings.camera_near_plane": "Камера рядом с плоскостью",
	"settings.camera_near_plane.desc": "Минимальная дистанция для рендеринга элементов. Бо́льшие значения устраняют Z-файтинг (мигающие грани). По умолчанию – 0.",
	"mode.start.keymap_preference.desc": "Если ты новичок в Blockbench или используешь другие утилиты для 3D-моделирования, можешь выбрать схему управления для лучшей адаптации. Позже ты сможешь изменить это в настройках.",
	"message.load_keymap": "Загрузить эту схему? Она перезапишет текущие горячие клавиши.",
	"message.keymap_loaded": "Схема загружена",
	"dialog.convert_project.current_format": "Текущий формат",
	"dialog.create_texture.rearrange_uv.desc": "Создай новое расположение UV, чтобы придать каждой стороне своё собственное место на текстуре",
	"dialog.create_texture.power.desc": "Создать текстуру с размером, кратным ближайшей степени двойки (например, 32, 64, 128). Может понадобиться при рендеринге.",
	"dialog.create_texture.double_use.desc": "Если две грани имеют одинаковое положение UV, оставить это на новой текстуре",
	"dialog.create_texture.padding.desc": "Добавить отступ между отдельными частями текстуры",
	"dialog.create_texture.resolution.desc": "Высота и ширина текстуры",
	"dialog.create_gif.color": "Цвет фона",
	"dialog.save_angle.zoom": "Приближение",
	"dialog.skin.variant": "Вариант",
	"dialog.flip_animation.info": "Противоположные кости идентифицируются ключевыми словами 'left' и 'right' в их названии.",
	"dialog.export_private_settings.title": "Приватные настройки",
	"dialog.export_private_settings.message": "Твой файл содержит следующую личную информацию: **%0**. Удали эти значения, если планируешь с кем-то делиться этим файлом.",
	"dialog.export_private_settings.keep": "Удержать",
	"settings.timecode_frame_number": "Показывать тайм-коды как номера кадров",
	"settings.timecode_frame_number.desc": "Отображать временные коды дробей на временной шкале в виде номера кадра вместо сантисекунды",
	"settings.animation_sample_rate": "Частота выборки анимации",
	"settings.animation_sample_rate.desc": "Частота в выборках в секунду для кривых, которые соответствующий формат изначально не поддерживают",
	"keybind.preview_zoom": "Вид увеличения",
	"action.gradient_tool": "Градиент",
	"action.gradient_tool.desc": "Сделать цветной градиент на текстуре",
	"action.import_settings": "Импортирование настроек",
	"action.import_settings.desc": "Импортировать файл .bbsettings",
	"action.export_settings": "Экспортировать настройки",
	"action.export_settings.desc": "Экпортировать настройки Blockbench как файл .bbsettings",
	"action.load_keymap": "Загрузка горячих клавиш",
	"action.load_keymap.default": "Стандартный (тачпад/мышь)",
	"action.load_keymap.mouse": "По умолчанию (мышь)",
	"action.load_keymap.default.desc": "Стандартная схема управления Blockbench с элементами управления просмотром, оптимизированными для использования на тачпадах ноутбуков",
	"action.load_keymap.mouse.desc": "Привязки клавиш Blockbench по умолчанию, при этом навигация по области просмотра привязана к средней кнопке мыши.",
	"action.load_keymap.blender.desc": "Назначение клавиш для пользователей, знакомых с Blender",
	"action.load_keymap.cinema4d.desc": "Назначение клавиш для пользователей, знакомых с Cinema 4D",
	"action.load_keymap.maya.desc": "Назначение клавиш для пользователей, знакомых с Autodesk Maya",
	"action.import_keymap": "Импортирование горячих клавиш",
	"action.import_keymap.desc": "Импортировать назначение клавиш из файла типа .bbkeymap",
	"action.export_keymap": "Экспорт горячих клавиш",
	"action.export_keymap.desc": "Экспортировать горячие клавиши в файл расширения .bbkeymap",
	"action.edit_history": "История...",
	"action.edit_history.desc": "Просмотр истории изменений и отмена/возврат действий",
	"action.group_elements": "Группа элементов",
	"action.group_elements.desc": "Закрыть выбранные предметы в новую группу",
	"action.unfold_groups": "Раскрыть группы",
	"action.unfold_groups.desc": "Раскрыть все группы в планировщике",
	"action.edit_bedrock_binding": "Привязка костей...",
	"action.edit_bedrock_binding.desc": "Изменить то, к какой кости привязана геометрия элемента",
	"action.pick_screen_color": "Выбор цвета с экрана",
	"action.pick_screen_color.desc": "Выбрать оттенок с экрана компьютера",
	"action.view_mode": "Режим просмотра",
	"action.view_mode.desc": "Изменить режим просмотра модели",
	"action.view_mode.textured": "Текстурированный",
	"action.view_mode.solid": "Сплошной",
	"action.view_mode.wireframe": "Каркас",
	"action.toggle_sidebars": "Переключить боковую панель",
	"action.toggle_sidebars.desc": "Включить/отключить боковую панель",
	"action.set_animation_end": "Установить Конец Анимации",
	"action.set_animation_end.desc": "Назначить конец выбранной анимации на нынешнее время таймлайна",
	"action.flip_animation": "Переворот анимации",
	"action.flip_animation.desc": "Отразить часть анимации с помощью копирования выбранных кадров на другую сторону модели",
	"action.graph_editor_zero_line": "Отображение нулевой линии",
	"action.graph_editor_zero_line.desc": "Всегда ли редактор графика включает нулевую линию в рассмотрение",
	"menu.texture.render_mode": "Режим рендеринга",
	"menu.texture.render_mode.emissive": "Эмиссивный",
	"menu.texture.render_mode.layered": "Послойный",
	"menu.preview.angle.edit": "Редактировать угол...",
	"menu.animation.start_delay": "Начать задержку",
	"menu.animation.loop_delay": "Зациклить задержку",
	"menu.animation.flip_keyframes": "Отразить ключевые кадры",
	"menu.mobile_keyboard.disable_all": "Отключить все",
	"panel.keyframe.toggle_uniform_scale": "Включить единый масштаб",
	"camera_angle.common_isometric_right": "Изометрия справа (2:1)",
	"camera_angle.common_isometric_left": "Изометрический левый (2:1)",
	"camera_angle.true_isometric_right": "Истинная изометрия справа (30°)",
	"camera_angle.true_isometric_left": "Истинная изометрия слева (30°)",
	"menu.help.wiki": "Blockbench Wiki",
	"settings.update_to_prereleases": "Обновление до предварительных выпусков",
	"settings.update_to_prereleases.desc": "Автоматически обновляться до бета-версий Blockbench для тестирования новых функций. Предварительные версии могут быть нестабильными, не включай эту опцию, если ты полагаешься на Blockbench для важных проектов.",
	"data.separator.spacer": "Распорка",
	"data.separator.linebreak": "Разрыв строки",
	"data.setting": "Настройка",
	"generic.select_all": "Выбрать всё",
	"generic.select_none": "Отменить выделение",
	"projects.new_tab": "Новая вкладка",
	"projects.close_tab": "Закрыть вкладку",
	"message.invalid_format.title": "Неверный формат",
	"message.invalid_format.message": "Эта модель создана в формате %0, который недоступен в твоём Blockbench. Скорее всего, тебе понадобится плагин для его открытия.",
	"message.invalid_link": "Неправильная или устаревшая ссылка на модель",
	"message.default_textures.current": "Текущий путь",
	"message.update_after_restart": "Обновление будет установлено при следующем запуске",
	"message.copy_paste_tool_viewport": "Этот инструмент может быть использован только в UV панели",
	"dialog.project.shadow_size": "Размер тени",
	"dialog.find_replace.target": "Цель",
	"dialog.find_replace.target.element_names": "Названия элементов",
	"dialog.find_replace.target.group_names": "Названия групп",
	"dialog.find_replace.target.animation_names": "Названия анимаций",
	"dialog.find_replace.target.keyframe_values": "Значения ключевых кадров",
	"dialog.find_replace.find": "Найти",
	"dialog.find_replace.replace": "Заменить",
	"dialog.find_replace.regex": "Обычное выражение",
	"dialog.add_primitive.shape": "Форма",
	"dialog.add_primitive.shape.circle": "Круг",
	"dialog.add_primitive.shape.tube": "Труба",
	"dialog.add_primitive.shape.cone": "Конус",
	"dialog.add_primitive.shape.cylinder": "Цилиндр",
	"dialog.add_primitive.shape.sphere": "Сфера",
	"dialog.add_primitive.shape.torus": "Торус",
	"dialog.add_primitive.shape.cube": "Параллелепипед",
	"dialog.add_primitive.shape.pyramid": "Пирамида",
	"dialog.add_primitive.diameter": "Диаметр",
	"dialog.add_primitive.height": "Высота",
	"dialog.add_primitive.sides": "Стороны",
	"dialog.add_primitive.minor_diameter": "Толщина",
	"dialog.add_primitive.minor_sides": "Малые сегменты",
	"dialog.create_texture.combine_polys": "Сшить UV-острова",
	"dialog.create_texture.combine_polys.desc": "Объединить грани в кластеры UV-островов",
	"dialog.model_stats.meshes": "Мэши",
	"dialog.export_private_settings.omit": "Выпустить",
	"layout.select": "Выбрать",
	"layout.options": "Настройки",
	"layout.color": "Цветовая схема",
	"layout.documentation": "Документация",
	"layout.color.bright_ui_text": "Яркий UI",
	"layout.color.bright_ui_text.desc": "Текст на ярких фонах",
	"layout.name": "Имя",
	"layout.author": "Автор",
	"settings.dialog.desc": "Показывать диалог \"%0\"",
	"settings.export_empty_groups": "Экспортировать пустые группы",
	"settings.export_empty_groups.desc": "Включать группы без контента в экспортированных файлах",
	"category.separators": "Разъеденители",
	"keybind.preview_area_select": "Выбор Области",
	"action.color_erase_mode": "Режим стирания",
	"action.color_erase_mode.desc": "При включенном режиме стирания такие инструменты, как «Заливка» и «Прямоугольник», вычитают цвета, а не добавляют их.",
	"action.open_from_link": "Открытие модели по ссылке...",
	"action.open_from_link.desc": "Открыть модель из blckbn.ch URL",
	"action.import_obj": "Импортирование модели OBJ",
	"action.import_obj.desc": "Импортировать содержимое OBJ-модели",
	"action.add_plugin": "Установка плагина",
	"action.add_plugin.desc": "Установить плагин через Action Control",
	"action.remove_plugin": "Удалить плагин",
	"action.remove_plugin.desc": "Сгрузить плагин через Action Control",
	"action.add_mesh": "Добавление мэша",
	"action.add_mesh.desc": "Добавить новый мэш на сетку редактирования",
	"action.add_texture_mesh": "Добавление мэша с текстурой",
	"action.add_texture_mesh.desc": "Добавить на сетку редактирования мэш с текстурой",
	"action.find_replace": "Поиск/замена",
	"action.find_replace.desc": "Найти и заменить части имён",
	"action.hide_everything_except_selection": "Спрятать всё кроме выбора",
	"action.hide_everything_except_selection.desc": "Переключить видимость всех элементов кроме тех что выбраны",
	"action.transform_space.normal": "Обычный",
	"action.selection_mode": "Режим выбора",
	"action.selection_mode.desc": "Изменить как элементы могут быть выбраны в окне просмотра",
	"action.selection_mode.object": "Объект",
	"action.selection_mode.face": "Грань",
	"action.selection_mode.vertex": "Вершина",
	"action.create_face": "Создание грани или ребра",
	"action.create_face.desc": "Создаёт новою грань или ребро между выбранными вершинами",
	"action.convert_to_mesh": "Конвертация в мэш",
	"action.convert_to_mesh.desc": "Конвертировать выбранные элементы в мэши",
	"action.invert_face": "Инверсия грани",
	"action.invert_face.desc": "Инвертировать выбранные грани, чтобы они были направлены в противоположном направлении",
	"action.extrude_mesh_selection": "Экструдирование",
	"action.extrude_mesh_selection.desc": "Выдавить выбранные части мэша",
	"action.loop_cut": "Разрезать петлёй",
	"action.loop_cut.desc": "Разделить меш по выбранному ребру вдоль петли",
	"action.merge_meshes": "Объединение мэшей",
	"action.merge_meshes.desc": "Объединение нескольких мэшей в один",
	"action.keyframe_uniform": "Равномерное масштабирование",
	"action.keyframe_uniform.desc": "Включить равномерное масштабирование для выбранных ключевых кадров",
	"menu.locator.ignore_inherited_scale": "Игнорировать унаследованный масштаб",
	"menu.texture.elements": "Применить для элементов",
	"uv_editor.transparent_face": "Прозрачная грань",
	"display.pose_angle": "Угол позы (только для предварительного просмотра)",
	"data.mesh": "Мэш",
	"dialog.create_texture.type": "Тип",
	"dialog.create_texture.type.blank": "Пустота",
	"dialog.create_texture.type.template": "Шаблон",
	"dialog.create_texture.type.color_map": "Сплошной цвет",
	"dialog.sketchfab_uploader.suggested_tags": "Предлагаемые теги",
	"dialog.sketchfab_uploader.category": "Категория",
	"dialog.sketchfab_uploader.category2": "Категория 2",
	"layout.restore_backup": "Пользовательская тема \"%0\" перезаписана. Нажми, чтобы сбросить её.",
	"layout.borders": "Края",
	"action.fill_mode.element": "Элемент",
	"action.inset_mesh_selection": "Вставка выделения",
	"action.inset_mesh_selection.desc": "Вставь выбранные части мэша",
	"action.dissolve_edges": "Растворение краёв",
	"action.dissolve_edges.desc": "Растворить выбранные ребра в сетке и объединить грани, разделяемые ими",
	"action.split_mesh": "Разделение мэшей",
	"action.split_mesh.desc": "Отделить выбранные грани в новый мэш",
	"action.merge_vertices": "Объединение вершин",
	"action.merge_vertices.desc": "Объединить выбранные вершины в положение первой выбранной вершины",
	"action.view_mode.normal": "Ориентация грани",
	"action.snap_uv_to_pixels": "Привязать UV к пикселям",
	"action.snap_uv_to_pixels.desc": "Привязывает выбранные вершины UV к пиксельной сетке.",
	"menu.file.import.import_open_project": "Импортировать открытый проект",
	"menu.help.unlock_projects": "Разблокировать все проекты",
	"status_bar.selection.faces": "%0 грани",
	"status_bar.selection.vertices": "%0 вершины",
	"message.merged_vertices": "Найдены и объединены %0 вершины в %1 местах",
	"settings.vertex_merge_distance": "Расстояние для слияния вершин",
	"settings.vertex_merge_distance.desc": "Расстояние, в пределах которого вершины объединяются с помощью объединения по расстоянию",
	"settings.show_only_selected_uv": "Показать только выбранные UV",
	"settings.show_only_selected_uv.desc": "Отображение только выбранных UV-граней в UV-редакторе по умолчанию.",
	"action.merge_vertices.merge_all": "К первой вершине",
	"action.merge_vertices.merge_all_in_center": "К центру всех вершин",
	"action.merge_vertices.merge_by_distance": "По ближайшим вершинам",
	"action.merge_vertices.merge_by_distance_in_center": "По ближайшим в центре",
	"action.uv_rotate_left": "Повернуть UV влево",
	"action.uv_rotate_left.desc": "Поверни выбранные грани UV против часовой стрелки",
	"action.uv_rotate_right": "Повернуть UV вправо",
	"action.uv_rotate_right.desc": "Поверни выбранные грани UV по часовой стрелке.",
	"menu.uv.display_uv": "Дисплей UV",
	"menu.uv.display_uv.selected_faces": "Выбранные грани",
	"menu.uv.display_uv.selected_elements": "Все грани",
	"menu.uv.display_uv.all_elements": "Все грани на всех элементах",
	"menu.paste.face": "Грань UV",
	"menu.paste.mesh_selection": "Выбор мэша",
	"menu.paste.outliner": "Элементы",
	"uv_editor.show_all_faces": "Показать все грани",
	"uv_editor.show_selected_faces": "Показать выбранные грани",
	"status_bar.selection.edges": "%0 рёбр",
	"action.selection_mode.edge": "Ребро",
	"message.cannot_re_import.title": "Модель невозможно ре-импортировать",
	"message.cannot_re_import.message": "Формат экспортированной модели не может быть переимпортирован в Blockbench. Убедись, что модель сохранена в проектном виде",
	"generic.default": "По умолчанию",
	"units.pixels_per_meter": "%0 пикселей на метр",
	"mode.pose": "Поза",
	"modifier_actions.resize_both_sides": "Изменение размера в обоих направлениях",
	"modifier_actions.resize_one_side": "Изменение размера в одном направлении",
	"modifier_actions.draw_line": "Нарисовать линию",
	"modifier_actions.drag_without_snapping": "Перетаскивание без привязки",
	"modifier_actions.stretch_keyframes": "Растянуть ключевые кадры",
	"modifier_actions.resize_background": "Изменить размер фона",
	"modifier_actions.select_multiple": "Выбери несколько",
	"modifier_actions.select_range": "Выбрать период",
	"modifier_actions.drag_to_duplicate": "Перетащи, чтобы дублировать",
	"modifier_actions.uniform_scaling": "Равномерное масштабирование",
	"modifier_actions.snap_direction": "Привязать направление",
	"message.no_valid_elements": "Не выбрано действительных элементов...",
	"dialog.add_primitive.shape.plane": "Плоскость",
	"dialog.save_angle.rotation_mode": "Режим вращения",
	"dialog.save_angle.rotation": "Вращение",
	"dialog.save_angle.fov": "FOV",
	"settings.hide_tab_bar": "Автоматически скрывать панель вкладок",
	"settings.hide_tab_bar.desc": "Скрывать панель вкладок когда открыта одна вкладка",
	"settings.status_bar_modifier_keys": "Предлагать ключи-модификаторы в строке состояния",
	"settings.status_bar_modifier_keys.desc": "Отображение контекстно-зависимых предлагаемых клавиш-модификаторов в строке состояния",
	"settings.ground_plane": "Плоскость земли",
	"settings.ground_plane.desc": "Показывать плоскость под моделью",
	"settings.preview_paste_behavior": "Предпросмотр вставки по умолчанию",
	"settings.preview_paste_behavior.desc": "Выбрать, что будет вставляться из буфера обмена в режиме редактирования, если в нём несколько значений",
	"settings.preview_paste_behavior.always_ask": "Всегда спрашивать",
	"action.new_window": "Новое окно",
	"action.new_window.desc": "Открыть новое окно Blockbench",
	"action.export_collada": "Экспорт Collada (DAE)",
	"action.export_collada.desc": "Экспортировать модель и анимации как DAE-файл для использования в других программах",
	"action.paint_mode_uv_overlay": "UV-наложение",
	"action.paint_mode_uv_overlay.desc": "Отображение UV-карты в виде наложения в режиме рисования",
	"action.bake_animation_into_model": "Запечь анимации в модель",
	"action.bake_animation_into_model.desc": "Запеки отображаемый кадр анимации в модель. Применяется только вращение и положение, масштаб игнорируется.",
	"action.keyframe_interpolation.step": "Пошаговый",
	"action.set_ik_target": "Установить цель IK",
	"action.set_ik_target.desc": "Выбери целевую кость, которая должна быть перемещена этим нулевым объектом с помощью инверсной кинематики.",
	"menu.action_control.type.tab": "Вкладка",
	"menu.action_control.type.angle": "Угол камеры",
	"menu.action_control.recent_in_streamer_mode": "Точно? Режим стримера включён",
	"menu.action_control.recent_in_streamer_mode.desc": "Ты точно хочешь отображать последние модели?",
	"menu.tools": "Инструменты",
	"menu.file.recent.more": "Смотреть ещё...",
	"menu.null_object.lock_ik_target_rotation": "Блокировка поворота цели IK",
	"menu.animation_file.import_remaining": "Импорт остатка из файла",
	"edit.loop_cut.offset": "Компенсировать",
	"edit.extrude_mesh_selection.extend": "Продлевать",
	"cube.color.pink": "Розовый",
	"cube.color.silver": "Серебристый",
	"dialog.plugins.offline": "Нет подключения к интернету",
	"dialog.create_texture.pixel_density": "Плотность пикселей",
	"dialog.create_texture.pixel_density.desc": "Плотность пикселей текстуры, измеряемая в пикселях на метр. Размер текстуры может варьироваться в зависимости от количества и размеров элементов.",
	"panel.skin_pose": "Поза",
	"panel.skin_pose.none": "Нет",
	"panel.skin_pose.natural": "Натурально",
	"panel.skin_pose.walking": "Ходьба",
	"panel.skin_pose.crouching": "Ползание",
	"panel.skin_pose.sitting": "Сидение",
	"panel.skin_pose.jumping": "Прыжок",
	"panel.skin_pose.aiming": "Прицеливание",
	"edit.loop_cut.direction": "Направление",
	"data.texture_mesh": "Текстура мэша",
	"generic.left": "Левый",
	"generic.right": "Правый",
	"mode.start.quick_setup": "Быстрая установка",
	"mode.start.keymap": "раскладка",
	"mode.start.quick_setup.more_themes": "Более...",
	"dialog.resize_texture.animation_frames": "Кадры анимации",
	"dialog.export_emission_map.title": "Экспортировать Emission карту",
	"dialog.export_emission_map.format": "Формат",
	"dialog.export_emission_map.format.luminance": "Яркость",
	"dialog.export_emission_map.format.luminance_inverted": "Инвертированная яркость",
	"dialog.export_emission_map.format.colors": "Цвета",
	"dialog.export_emission_map.threshold": "Предел прозрачности",
	"dialog.export_emission_map.round_up": "Округлить до %0 x %1",
	"dialog.export_emission_map.flip_y": "Отразить Y ось",
	"dialog.select.type": "Тип элемента",
	"dialog.create_texture.max_edge_angle": "Порог угла ребра",
	"dialog.create_texture.max_edge_angle.desc": "Максимальный угол между двумя гранями для объединения в UV-остров",
	"dialog.create_texture.max_island_angle": "Порог угла UV-острова",
	"dialog.create_texture.max_island_angle.desc": "Максимальный угол между нормалями для объединения в UV-остров",
	"settings.mobile_panel_side": "Сторона мобильной панели",
	"settings.mobile_panel_side.desc": "Выберите, на какой стороне экрана будут отображаться панели при использовании Blockbench в альбомной ориентации.",
	"settings.obj_face_export_mode": "Режим OBJ экспорта граней",
	"settings.obj_face_export_mode.desc": "Выбери, чтобы разрешить OBJ-экспортеру конвертировать все грани в треугольники или четырёхугольники",
	"settings.obj_face_export_mode.both": "По умолчанию",
	"settings.obj_face_export_mode.tris": "Конвертировать в треугольники",
	"settings.obj_face_export_mode.quads": "Конвертировать в четырёхугольники",
	"action.seam_tool": "Инструмент «Шов»",
	"action.seam_tool.desc": "Инструмент для определения UV-швов на краях сетки.",
	"action.resolve_group": "Группа разрешения",
	"action.resolve_group.desc": "Разрешить группу, сохраняя ее дочерние элементы в том же месте",
	"action.move_to_group": "Перемещение в группу",
	"action.move_to_group.desc": "Переместить выбранные элементы в другую группу планировщика",
	"action.select_seam": "Выбери UV-шов",
	"action.select_seam.desc": "Выбери режим шва UV для выбранных краев.",
	"action.select_seam.auto": "Авто",
	"action.select_seam.join": "Присоединить",
	"action.select_seam.divide": "Разделить",
	"action.adjust_brightness_contrast": "Яркость и контрастность...",
	"action.adjust_brightness_contrast.desc": "Отрегулировать яркость и контрастность выбранной текстуры",
	"action.adjust_saturation_hue": "Насыщенность и оттенок...",
	"action.adjust_saturation_hue.desc": "Отрегулировать насыщенность и оттенок выбранной текстуры",
	"action.invert_colors": "Инверсия цвета",
	"action.invert_colors.desc": "Инвертировать все цвета выбранной текстуры",
	"action.adjust_curves": "Кривые...",
	"action.adjust_curves.desc": "Отрегулировать кривые яркости выбранной текстуры",
	"action.flip_texture_x": "Отражение по-горизонтали",
	"action.flip_texture_y": "Отражение по-вертикали",
	"action.resize_texture": "Изменить размер текстуры...",
	"action.view_mode.uv": "Предварительный просмотр UV",
	"action.append_to_template": "Добавление элемента в шаблон...",
	"action.append_to_template.desc": "Добавить выбранные в данный момент элементы в шаблон текстуры",
	"action.move_texture_with_uv": "Сдвиг текстуры с помощью UV",
	"action.move_texture_with_uv.desc": "Перемещай текстуру лица при перетаскивании UV-граней",
	"action.timeline_setups": "Настройки временной шкалы",
	"action.save_timeline_setup": "Сохранить настройку временной шкалы...",
	"action.save_timeline_setup.desc": "Сохранить шаблон для выбранных в данный момент аниматоров и каналов",
	"menu.texture": "Текстура",
	"menu.texture.render_mode.default": "Обычный",
	"menu.texture.merge_onto_texture": "Слияние С Текстурой Выше",
	"menu.animation.unload": "Разгрузить",
	"panel.timeline": "Таймлайн",
	"action.pan_tool": "Инструмент панорамирования",
	"action.pan_tool.desc": "Инструмент для навигации в окне просмотра и редакторе текстур",
	"mode.start.recent.favorite": "Пометить как избранное",
	"mode.start.info": "Информация",
	"mode.start.target": "Предназначена для",
	"mode.start.start": "Начинать",
	"mode.start.create_new": "Создать новую модель",
	"mode.start.format.informations": "Факты касательно этого типа модели:",
	"mode.start.format.resources": "Ресурсы:",
	"format.free.info.meshes": "В этом формате ты можешь создавать низкополигональные модели, используя кубы и мэши нестандартной формы.",
	"format.free.info.limitation": "Модели нельзя загружать в игры, которым нужны специализированные форматы, такие как Minecraft.",
	"format.skin.info.skin": "Этот формат предназначен для создания скинов Minecraft и текстур сущностей.",
	"format.skin.info.model": "Модель не может быть изменена. Чтобы внести изменения в модель, преобразуй её в другой формат.",
	"format.java_block.info.rotation": "Вращения ограничены шагами в 22,5 градуса и одной осью на элемент.",
	"format.java_block.info.size": "Модель ограничена размером 3 на 3 на 3 блока. Однако настройки отображения могут сделать модели предметов больше до четырёх раз.",
	"format.java_block.info.animation": "Этот формат не поддерживает анимацию для Minecraft JE. При создании модов можно использовать движок GeckoLib для анимации моделей.",
	"format.bedrock.info.textures": "Каждая модель может иметь только одну текстуру",
	"format.bedrock_block": "Блок Minecraft BE",
	"format.bedrock_block.desc": "Модель блока для Minecraft BE",
	"format.modded_entity.info.integer_size": "Размер отдельных кубов ограничен целыми числами.",
	"format.modded_entity.info.format": "Модели записываются в коде Java, а не в специальных структурах данных, как во всех других форматах экспорта Blockbench.",
	"format.optifine_entity.info.optifine_required": "Пользователи без установленного OptiFine не увидят модель.",
	"format.optifine_entity.info.pivots": "Костные шарниры заблокированы, поэтому рекомендуется оставить их нетронутыми.",
	"format_category.low_poly": "Низкополигональная",
	"format_category.minecraft": "Minecraft",
	"format_category.other": "Другое",
	"format_category.loaders": "Загрузчик",
	"message.recover_backup.recover": "Восстановить",
	"message.invalid_characters.title": "Неверный путь",
	"message.invalid_characters.message": "Путь к импортируемому файлу содержит недопустимые символы, буквы верхнего регистра или пробелы. Поддерживаемые символы: %0",
	"dialog.share_model.thumbnail": "Миниатюра",
	"dialog.skin.high_res_texture": "Обрати внимание, что скины с выбранным разрешением не будут работать как обычные скины Minecraft. Выбери меньшее разрешение.",
	"settings.allow_display_slot_mirror": "Разрешить зеркалирование слота дисплея",
	"settings.allow_display_slot_mirror.desc": "Разрешить зеркальное отображение слотов отображения для моделей элементов Java. Внимание: Это работает только до версии Minecraft 1.14 или в некоторых особых случаях.",
	"action.switch_tabs": "Переключить вкладки",
	"action.switch_tabs.desc": "Цикл между открытыми вкладками. Удерживай Shift для переключения в обратном направлении.",
	"action.unselect_all": "Снять все",
	"action.save_palette": "Сохранить палитру...",
	"action.save_palette.desc": "Сохрани текущую цветовую палитру в Blockbench для последующего использования.",
	"action.keyframe_column_create": "Создать столбец ключевого кадра",
	"action.keyframe_column_create.desc": "Включи все каналы на временной шкале с текущим временным кодом, если у них уже есть ключевые кадры.",
	"action.keyframe_column_select": "Выбери столбец ключевого кадра",
	"action.keyframe_column_select.desc": "Выбери все ключевые кадры на временной шкале в столбце под указателем воспроизведения.",
	"menu.uv": "UV",
	"menu.keyframe": "Ключевой кадр",
	"menu.palette.load.update": "Обновить палитру",
	"menu.palette.load.update.desc": "Обновляет эту палитру цветами текущей палитры Blockbench.",
	"menu.timeline_marker.set_time": "Установить время...",
	"uv_editor.scale_uv": "Шкала UV",
	"action.preview_scene": "Предпросмотр сцены",
	"action.preview_scene.desc": "Изменить сцену предварительного просмотра модели",
	"preview_scene.minecraft_overworld": "Верхний мир",
	"preview_scene.minecraft_nether": "Чистилище",
	"preview_scene.minecraft_end": "Край",
	"dialog.project.modded_entity_flip_y": "Отразить ось Y",
	"preview_scene.studio": "Студия",
	"format.image": "Изображение",
	"modifier_actions.set_copy_source": "Установить источник копирования",
	"message.load_images.title": "Загрузить изображения",
	"message.load_images.edit_image": "Редактировать изображение",
	"dialog.add_primitive.align_edges": "Выровнять края",
	"dialog.flip_animation.show_in_timeline": "Показать измененные кости на временной шкале",
	"settings.default_cube_size": "Размер куба",
	"settings.default_cube_size.desc": "Установить размер куба по умолчанию при создании нового куба",
	"settings.uniform_keyframe": "Ключевые кадры единого масштаба",
	"settings.uniform_keyframe.desc": "Установи масштабирование ключевых кадров на равномерное масштабирование по умолчанию.",
	"settings.nearest_rectangle_select": "Выбор прямоугольника: ближайший край",
	"settings.nearest_rectangle_select.desc": "Привязать выделенные прямоугольники к ближайшему краю пикселя, как в GIMP, а не к целым пикселям.",
	"settings.pick_color_opacity": "Выбери непрозрачность цвета",
	"settings.pick_color_opacity.desc": "Выбери непрозрачность цвета с помощью палитры цветов и установи её в качестве непрозрачности кисти.",
	"settings.paint_with_stylus_only": "Рисовать только со стилусом",
	"settings.paint_with_stylus_only.desc": "Используй только стилус для рисования, резервную мышь или сенсорный ввод для навигации.",
	"action.copy_brush_mode": "Копирование режима кисти",
	"action.copy_brush_mode.copy": "Копирование",
	"action.copy_brush_mode.pattern": "Шаблон",
	"action.copy_brush_mode.sample": "Образец",
	"action.brush_shape": "Форма кисти",
	"action.brush_shape.square": "Квадрат",
	"action.brush_shape.circle": "Круг",
	"action.blend_mode": "Режим наложения",
	"action.blend_mode.default": "Обычный",
	"action.blend_mode.set_opacity": "Непрозрачность",
	"action.blend_mode.color": "Цветовой тон",
	"action.blend_mode.behind": "Подложка",
	"action.blend_mode.multiply": "Умножение",
	"action.blend_mode.divide": "Разделить",
	"action.blend_mode.add": "Линейное выгорание",
	"action.blend_mode.subtract": "Вычитание",
	"action.blend_mode.screen": "Экран",
	"action.blend_mode.overlay": "Наложение",
	"action.blend_mode.hard_light": "Жёсткий свет",
	"action.blend_mode.difference": "Разница",
	"action.copy_brush": "Копирование кисти",
	"action.copy_brush.desc": "Кисть для клонирования части текстуры или создания узоров. Удерживая Ctrl, нажми, чтобы выбрать источник копирования.",
	"action.validator_window": "Просмотр проблем с моделью...",
	"action.validator_window.desc": "Открыть профилировщик, чтобы увидеть проблемы с текущей моделью.",
	"action.cancel_gif": "Отмена GIF",
	"menu.text_edit.copy_vector": "Копировать вектор",
	"menu.brush_presets.dialog": "Предустановки кистей...",
	"menu.brush_presets.pixel_brush": "Пиксельная кисть",
	"menu.brush_presets.smooth_brush": "Гладкая кисть",
	"menu.texture.edit_in_blockbench": "Редактировать в Blockbench",
	"menu.mirror_painting.axis": "Ось",
	"menu.mirror_painting.axis.desc": "Выберите, по какой оси штрихи краски будут отражаться",
	"menu.mirror_painting.global": "Глобальная симметрия",
	"menu.mirror_painting.global.desc": "Включено зеркальное рисование на модели в рабочем пространстве",
	"menu.mirror_painting.local": "Локальная симметрия",
	"menu.mirror_painting.local.desc": "Включить зеркальное рисование в локальном пространстве для каждого элемента",
	"menu.mirror_painting.texture_frames": "Повтор на кадрах анимированных текстур",
	"menu.mirror_painting.texture_frames.desc": "Отражай мазки краской в ​​каждом кадре анимированных текстур.",
	"format.bedrock_block.info.size_limit": "Общий размер блока ограничен 30 пикселями во всех измерениях. Предел может быть смещён во всех направлениях на 7 пикселей от центра блока.",
	"format.bedrock_block.info.textures": "Несколько текстур можно применять к разным кубам в Blockbench, но для их правильной работы требуется дополнительная настройка в пакете поведения.",
	"format.image.desc": "Редактировать изображения в редакторе 2D-изображений",
	"generic.delete_all": "Удалить всё",
	"message.child_model_only.open": "Открытый родитель",
	"message.child_model_only.open_with_textures": "Открыть родительские и принять текстуры",
	"dialog.project.credit": "Кредит",
	"dialog.convert_project.create_copy": "Создать копию",
	"dialog.texture.frame_time": "Время кадра",
	"dialog.texture.frame_time.desc": "Установи, как долго каждый кадр будет виден в тиках. Каждый тик равен 1/20 секунды.",
	"dialog.texture.frame_interpolate": "Интерполировать",
	"dialog.texture.frame_interpolate.desc": "Интерполировать кадры анимации путём плавного перехода к следующему кадру",
	"dialog.texture.frame_order_type": "Режим цикла",
	"dialog.texture.frame_order_type.loop": "Цикл",
	"dialog.texture.frame_order_type.backwards": "Обратный цикл",
	"dialog.texture.frame_order_type.back_and_forth": "Туда-сюда",
	"dialog.texture.frame_order_type.custom": "Своя последовательность",
	"dialog.texture.frame_order": "Порядок кадров",
	"dialog.texture.frame_order.desc": "Установить пользовательский порядок кадров, перечислив индексы кадров в новом порядке. Индексы кадров начинаются с 0.",
	"dialog.select.mode": "Режим",
	"dialog.select.mode.new": "Новый выбор",
	"dialog.select.mode.add": "Добавить в избранное",
	"dialog.select.mode.remove": "Удалить из выбранных",
	"dialog.select.mode.in_selection": "Выбрать только из выбранных",
	"dialog.predicate_overrides.model": "Модель",
	"dialog.predicate_overrides.predicates": "Предикаты",
	"dialog.predicate_overrides.variants": "Варианты",
	"dialog.predicate_overrides.start_value": "Начинать",
	"dialog.predicate_overrides.add_override": "Добавить переопределение",
	"dialog.predicate_overrides.add_predicate": "Добавить предикат",
	"dialog.predicate_overrides.generate_overrides": "Генерировать переопределения",
	"dialog.predicate_overrides.confirm_delete": "Ты хочешь удалить все переопределения?",
	"dialog.predicate_overrides.predicate.angle": "Угол компаса",
	"dialog.predicate_overrides.predicate.blocking": "Блокирует",
	"dialog.predicate_overrides.predicate.broken": "Сломан",
	"dialog.predicate_overrides.predicate.cast": "литой",
	"dialog.predicate_overrides.predicate.cooldown": "Остывать",
	"dialog.predicate_overrides.predicate.damage": "Повреждать",
	"dialog.predicate_overrides.predicate.damaged": "Поврежден",
	"dialog.predicate_overrides.predicate.lefthanded": "Левша",
	"dialog.predicate_overrides.predicate.pull": "Сумма вытягивания",
	"dialog.predicate_overrides.predicate.pulling": "Тянет",
	"dialog.predicate_overrides.predicate.charged": "Взимается",
	"dialog.predicate_overrides.predicate.firework": "Имеет фейерверк",
	"dialog.predicate_overrides.predicate.throwing": "Готов бросить",
	"dialog.predicate_overrides.predicate.time": "Время суток",
	"dialog.predicate_overrides.predicate.custom_model_data": "Пользовательские данные модели",
	"dialog.predicate_overrides.predicate.level": "Уровень освещенности",
	"dialog.predicate_overrides.predicate.filled": "Уровень заполнения пакета",
	"dialog.predicate_overrides.predicate.tooting": "Верно подмечено",
	"settings.model_export_scale": "Масштаб экспорта модели",
	"settings.model_export_scale.desc": "Коэффициент масштаба экспортируемых glTF, DAE и FBX моделей. Значение по умолчанию — 16, что преобразует 16 делений Blockbench в 1 метр при экспорте.",
	"action.export_fbx": "Экспорт FBX-модели",
	"action.export_fbx.desc": "Экспортировать модель и анимации как FBX-файл для использования в других программах",
	"action.center_lateral": "Боковое центрирование",
	"action.center_lateral.desc": "Центрировать выбранные элементы по осям X и Z",
	"action.adjust_opacity": "Непрозрачность...",
	"action.adjust_opacity.desc": "Отрегулировать непрозрачность выбранной текстуры",
	"action.rotate_texture_cw": "Повернуть по часовой стрелке",
	"action.rotate_texture_ccw": "Повернуть против часовой стрелки",
	"action.predicate_overrides": "Редактировать переопределения предикатов...",
	"action.predicate_overrides.desc": "Выбери модели для переопределения этой модели на основе выбранных условий",
	"action.auto_set_cullfaces": "Автоматически устанавливать кулфейсы",
	"action.auto_set_cullfaces.desc": "Автоматически генерировать кулфейсы, чтобы скрыть грани, перекрытые соседним блоком.",
	"menu.texture.edit_externally": "Внешнее редактирование",
	"menu.mirror_painting.texture": "Симметрия 2D-редактора",
	"menu.mirror_painting.texture.desc": "Включить симметричное рисование в 2D-пространстве",
	"menu.animator.rotation_global": "Вращение в глобальном пространстве",
	"uv_editor.face_properties": "Свойства грани",
	"uv_editor.face_properties.material_instance": "Экземпляр материала",
	"uv_editor.tint.info": "Оттенок можно включить на грани, чтобы сообщить Minecraft о необходимости подкрашивать её. По умолчанию оттенок имеет нулевое значение и может использоваться только определёнными блоками, такими как листва и пыль красного камня.",
	"uv_editor.cullface.info": "Включение кулфейс указывает грани элемента отменить рендеринг, если её загораживает другой цельный блок. Это необходимо для оптимизации.",
	"uv_editor.material_instance.info": "Экземплярам материала можно присвоить определяемое пользователем имя. Это имя можно использовать в файле блока JSON в пакете поведения, чтобы назначить конкретную текстуру и материал для лица.",
	"display.reference.frame_invisible": "Невидимая рамка",
	"data.settings_profile": "Профиль",
	"message.display_skin.invalid_name": "Не удаётся найти учетную запись Minecraft с ником ''%0''.",
	"dialog.load_plugins_from_query.title": "Загрузить плагины",
	"dialog.load_plugins_from_query.text": "Ты используешь ссылку, которая требует установки плагинов. Установить их?",
	"dialog.select_model.title": "Выбрать модель",
	"dialog.select_model.bones": "Кости",
	"dialog.select_model.cubes": "Кубы",
	"dialog.settings.create_profile": "Создать профиль...",
	"settings_profile.confirm_delete": "Ты уверен, что хочешь удалить этот профиль?",
	"settings_profile.condition.type.selectable": "Выбирается вручную",
	"settings.interface_mode": "Режим пользовательского интерфейса",
	"settings.interface_mode.desc": "Режим интерфейса. Перезапусти Blockbench, чтобы применить изменения",
	"settings.interface_mode.auto": "Автоматический",
	"settings.interface_mode.desktop": "Настольный",
	"settings.interface_mode.mobile": "Мобильный",
	"settings.paint_through_transparency": "Рисовать через прозрачность",
	"settings.paint_through_transparency.desc": "Рисовать через прозрачные пиксели при блокировке альфа-канала",
	"action.tab_overview": "Обзор вкладки",
	"action.tab_overview.desc": "Просмотр всех открытых вкладок в сетке и переход к одной из них",
	"action.slider_color_red": "Красный цвет",
	"action.slider_color_green": "Зелёный цвет",
	"action.slider_color_blue": "Синий цвет",
	"action.add_animation_controller": "Добавление контроллера анимаций",
	"action.add_animation_controller.desc": "Создать пустой контроллер анимации",
	"action.animation_controller_preview_mode": "Предпросмотр контроллера",
	"action.animation_controller_preview_mode.paused": "Приостановлено",
	"action.animation_controller_preview_mode.manual": "Ручной предпросмотр",
	"action.animation_controller_preview_mode.play": "Автопроигрывание",
	"action.keyframe_interpolation.bezier": "Кривая Безье",
	"action.keyframe_bezier_linked": "Link Ручки Безье",
	"action.keyframe_bezier_linked.desc": "Соедини правый и левый маркер Безье ключевого кадра",
	"action.reset_keyframe_handles": "Сбросить маркеры ключевого кадра",
	"action.reset_keyframe_handles.desc": "Сбросить маркеры Безье выбранных ключевых кадров",
	"action.looped_animation_playback": "Зацикленное воспроизведение",
	"action.looped_animation_playback.desc": "Предпросмотр анимации в бесконечном цикле",
	"timeline.bind_to_actor": "Привязать к актору",
	"animation_controllers.select_preset": "Выбери шаблон контроллера...",
	"animation_controllers.state.animations": "Анимации",
	"animation_controllers.state.particles": "Частицы",
	"animation_controllers.state.sounds": "Звуки",
	"animation_controllers.state.on_entry": "При въезде",
	"animation_controllers.state.on_exit": "На выходе",
	"animation_controllers.state.transitions": "Переходы",
	"animation_controllers.state.condition": "Состояние",
	"animation_controllers.state.blend_transition": "Время смешивания",
	"animation_controllers.state.shortest_path": "Смешать по кратчайшему пути",
	"animation_controllers.state.edit_transition": "Изменить переход",
	"menu.color_picker.picker_type": "Тип подборщика",
	"menu.color_picker.picker_type.square": "Квадрат",
	"menu.color_picker.picker_type.wheel": "Колесо",
	"menu.color_picker.slider_mode": "Режим слайдера",
	"menu.color_picker.slider_mode.hsv": "HSV",
	"menu.color_picker.slider_mode.rgb": "Красный, Зелёный, Синий",
	"menu.texture.render_mode.additive": "Сложение",
	"panel.color.picker_options": "Параметры палитры цветов",
	"panel.animation_controllers": "Контроллер анимации",
	"display.preset.armor_stand": "Пол (стойка для брони)",
	"data.file_path": "Путь до файлы",
	"dialog.extrude.orientation": "Ориентация",
	"dialog.extrude.orientation.upright": "Вертикальный",
	"dialog.extrude.orientation.flat": "Плоский",
	"dialog.scale.box_uv_warning": "Масштабирование модели Box UV может сломать UV твоей модели. Масштабируй модель целиком или переключись в Per-face UV Mode в меню проекта.",
	"dialog.create_gif.format": "Формат",
	"dialog.create_gif.format.gif": "GIF",
	"dialog.create_gif.format.png_sequence": "Последовательность PNG",
	"dialog.create_gif.pixelate": "Пикселизация",
	"dialog.create_gif.bg_image": "Фоновое изображение",
	"dialog.create_gif.turn.desc": "Оборачивать модель во время записи. Используй отрицательные значения, чтобы провернуть модель по часовой стрелке. Значение 60 соответствует одному обороту в секунду.",
	"settings_profile.condition": "Состояние",
	"settings_profile.condition.type.file_path.desc": "Применить RegEx-синтаксис для соответствия пути к файлу текущего проекта (используй слэш для директорий файлов)",
	"settings.only_selected_bezier_handles": "Показать только выбранные ручки Безье",
	"settings.only_selected_bezier_handles.desc": "Скрыть маркеры ключевых кадров Безье, которые в данный момент не выбраны",
	"settings.embed_textures": "Встроить текстуры",
	"settings.embed_textures.desc": "Встроить содержимое файла текстуры в файлы .bbmodel",
	"action.selection_mode.cluster": "Кластер",
	"dialog.copied_to_clipboard": "Скопировано в буфер обмена",
	"data.reference_image": "Референс",
	"message.delete_reference_image": "Ты уверен, что хочешь удалить этот референс? Это не может быть отменено.",
	"message.add_reference_image.message": "Выбери, куда загрузить референс",
	"message.add_reference_image.project": "Добавить только в этот проект",
	"message.add_reference_image.app": "Добавить во все проекты",
	"message.import_particle_texture.import": "Импорт текстуры частиц",
	"message.import_particle_texture.message": "Ты хочешь импортировать текстуру, используемую для твоей частицы?",
	"message.save_codec_selector.title": "Сохранить формат модели",
	"message.save_codec_selector.message": "Выбери формат для сохранения модели.",
	"message.save_codec_selector.project_file": "Проект Blockbench (.bbmodel)",
	"message.save_codec_selector.both": "Оба",
	"message.display_skin.username": "Имя пользователя (Java)",
	"message.palette_locked": "Палитра заблокирована",
	"dialog.project.default_uv_mode": "UV-режим по умолчанию",
	"dialog.project.default_uv_mode.description": "Установить UV-режим проекта по умолчанию. Режим UV также можно изменить для каждого элемента.",
	"dialog.export_options.title": "Параметры экспорта",
	"dialog.edit_texture.preview": "Предпросмотр",
	"dialog.proportional_editing.range": "Диапазон",
	"dialog.proportional_editing.falloff": "Спад",
	"dialog.proportional_editing.falloff.linear": "Линейный",
	"dialog.proportional_editing.falloff.hermite_spline": "Гладкий",
	"dialog.proportional_editing.falloff.constant": "Постоянный",
	"dialog.proportional_editing.selection": "Выбор",
	"dialog.proportional_editing.selection.linear": "Линейное расстояние",
	"dialog.proportional_editing.selection.connections": "Соединения",
	"dialog.mirror_painting_texture_center.middle": "Центр",
	"dialog.mirror_painting_texture_center.custom": "Пользовательский",
	"dialog.settings.reset_to_default": "Восстановление заводских настроек",
	"keybindings.item.num_slider.increase": "Увеличивать",
	"keybindings.item.num_slider.decrease": "Снижаться",
	"settings.always_show_splash_art": "Всегда показывать заставки",
	"settings.always_show_splash_art.desc": "Всегда отображать заставку на стартовом экране",
	"action.slider_palette_color": "Переключить цвет палитры",
	"action.slider_palette_color.desc": "Цикл между цветами в палитре",
	"action.proportional_editing": "Пропорциональное редактирование",
	"action.proportional_editing.desc": "Пропорционально влияет на окружающие вершины при редактировании частей сетки.",
	"action.limit_to_palette": "Ограничение палитрой",
	"action.limit_to_palette.desc": "Ограничивает цвета текстуры цветами из текущей загруженной палитры.",
	"action.edit_reference_images": "Изменение референсов",
	"action.edit_reference_images.desc": "Включи отображение референсов, чтобы редактировать референсы и чертежи.",
	"action.add_reference_image": "Добавление референса",
	"action.reference_image_from_clipboard": "Референс из буфера обмена",
	"action.reference_image_list": "Референсы",
	"action.connect_uv_faces": "Соединение UV-граней",
	"action.connect_uv_faces.desc": "Соедини выбранные UV-грани с последней выбранной UV-гранью",
	"action.merge_uv_vertices": "Объединение UV-вершин",
	"action.merge_uv_vertices.desc": "Привязать первые выбранные вершины UV к последним выбранным вершинам UV",
	"action.bedrock_animation_mode": "Режим анимации Minecraft BE",
	"action.bedrock_animation_mode.desc": "Выбери режим редактирования анимации для Minecraft BE в",
	"action.bedrock_animation_mode.entity": "Сущность",
	"action.bedrock_animation_mode.attachable_first": "Пункт 1-е лицо",
	"action.bedrock_animation_mode.attachable_third": "Пункт 3-е лицо",
	"timeline.amplify": "Усиление",
	"menu.options": "Параметры...",
	"menu.palette.lock_palette": "Заблокировать палитру",
	"menu.uv.export": "Экспорт UV-карты",
	"menu.uv.flip_x": "Зеркало Х",
	"menu.uv.flip_y": "Зеркало Y",
	"menu.mirror_painting.enabled": "Включено",
	"reference_image.position": "Позиция",
	"reference_image.size": "Размер",
	"reference_image.rotation": "Вращение",
	"reference_image.opacity": "Непрозрачность",
	"reference_image.visibility": "Видимость",
	"reference_image.clear_mode": "Очистить режим",
	"reference_image.layer": "Слой",
	"reference_image.layer.background": "Задний план",
	"reference_image.layer.viewport": "Передний план",
	"reference_image.layer.float": "Над интерфейсом",
	"reference_image.scope": "Объём",
	"reference_image.scope.project": "Только этот проект",
	"reference_image.scope.global": "Все проекты",
	"reference_image.enabled_modes": "Включено в режимах",
	"codec.common.encoding": "Кодирование",
	"codec.common.armature": "Экспортировать группы как арматуру",
	"codec.common.export_animations": "Экспорт анимации",
	"codec.common.embed_textures": "Встроить текстуры",
	"preview.center_camera": "Центральная камера",
	"display.reference.frame_top": "Верх рамки элемента",
	"display.reference.frame_top_invisible": "Верхняя часть рамки предмета (невидимая)",
	"action.proportional_editing_range": "Пропорциональный диапазон редактирования",
	"action.proportional_editing_range.desc": "Отрегулируй диапазон для пропорционального редактирования",
	"action.toggle_all_reference_images": "Скрыть/показать все референсы",
	"action.toggle_all_reference_images.desc": "Переключить видимость всех референсов одновременно",
	"action.add_animation_controller_state": "Добавление состояния контроллера",
	"action.add_animation_controller_state.desc": "Добавление нового состояния в контроллер",
	"menu.slider.round_value": "Круглое значение",
	"texture.error.too_large": "Разрешение превышает максимум %0",
	"dialog.copy_to_clipboard": "Скопировать в буфер обмена",
	"dialog.open_url": "Открыть URL",
	"reference_image.image": "Изображение",
	"uv_editor.rotate_uv": "Вращение UV",
	"generic.error": "Ошибка",
	"projects.start_screen": "Начальный экран",
	"message.invalid_link.message": "Модель %0, которую ты пытаешься загрузить, недействительна или доступ к ней истёк.",
	"message.plugin_dependencies.title": "Зависимости плагина",
	"message.plugin_dependencies.message1": "Плагин требует следующих зависимостей:",
	"message.plugin_dependencies.message1_update": "Плагин %0 был обновлен и теперь требует следующих зависимостей:",
	"message.plugin_dependencies.message2": "Хочешь установить их для продолжения?",
	"message.plugin_dependencies.invalid": "Плагин не может быть установлен, так как содержит недопустимую зависимость:",
	"message.preview_scene_load_failed": "Ошибка при загрузке сцены предварительного просмотра. Проверь своё соединение.",
	"dialog.convert_project.text1": "Конвертируй проект в другой формат.",
	"dialog.convert_project.text2": "Используй конвертацию на свой страх и риск – форматы имеют разные функции и ограничения, поэтому преобразование может привести к поломке отдельных частей проекта.",
	"dialog.convert_project.text3": "Ты не можешь отменить конвертацию, поэтому по умолчанию будет создана копия.",
	"dialog.unsaved_work.title": "Несохранённая работа",
	"dialog.unsaved_work.text": "Следующие проекты содержат несохранённые изменения. Сохранить изменения?",
	"dialog.unsaved_work.discard_all": "Отменить все",
	"dialog.unsaved_work.save_all": "Сохранить все",
	"dialog.resize_texture.mode": "Режим",
	"dialog.resize_texture.mode.crop": "Обрезать/расширить",
	"dialog.resize_texture.mode.scale": "Размер",
	"dialog.plugins.is_installed": "Установлено",
	"dialog.plugins.is_disabled": "Отключено",
	"dialog.plugins.disable": "Отключить",
	"dialog.plugins.enable": "Включить",
	"dialog.plugins.dependencies": "Зависит от:",
	"dialog.view_backups.open_folder": "Открыть папку",
	"dialog.share_model.reference_images": "Включать референсы в проект",
	"dialog.share_model.too_large": "Не удалось загрузить: Слишком большая модель.",
	"dialog.share_model.too_large_references": "Не удалось загрузить: Слишком большая модель. Попробуй убрать встроенные референсы.",
	"settings.stretch_linked": "Связное растяжение",
	"settings.stretch_linked.desc": "Растянуть куб во всех направлениях на одно и то же значение",
	"settings.grids": "Показать сетку",
	"settings.grids.desc": "Показать или скрыть сетку редактирования",
	"settings.double_click_switch_tools": "Переключать инструменты двойным щелчком",
	"settings.double_click_switch_tools.desc": "Дважды нажать по области просмотра для переключения между инструментами",
	"settings.outlines_in_paint_mode": "Контуры выделения в режиме рисования",
	"settings.outlines_in_paint_mode.desc": "Отображать контуры выделения элементов в режиме рисования",
	"settings.json_indentation": "Отступы JSON",
	"settings.json_indentation.desc": "Стиль отступов для экспортируемых JSON-файлов",
	"settings.json_indentation.tabs": "Табуляции",
	"settings.json_indentation.spaces_4": "Отступы: 4",
	"settings.json_indentation.spaces_2": "Отступы: 2",
	"action.slider_stretch": "Растянуть",
	"action.slider_stretch.desc": "Растягивает элементы вдоль оси %0, не изменяя UV-развёртку",
	"action.view_backups": "Посмотреть резервные копии",
	"action.view_backups.desc": "Просмотреть список резервных копий",
	"action.search_outliner": "Поиск в списке элементов",
	"action.search_outliner.desc": "Поиск по названиям элементов в списке",
	"action.mirror_modeling": "Симметричное моделирование",
	"action.mirror_modeling.desc": "Включить зеркальное моделирование вдоль оси X. Все изменения, которые ты вносишь в видовой экран, будут отображаться на другой стороне, если это не отключено для элемента.",
	"action.allow_element_mirror_modeling": "Симметричное моделирование",
	"action.allow_element_mirror_modeling.desc": "Выбери, могут ли выбранные элементы быть затронуты зеркальным моделированием",
	"action.switch_face_crease": "Складка граней",
	"action.switch_face_crease.desc": "Изменить направление, в котором сгибается грань по центру",
	"action.clear_unused_texture_space": "Чистка текстуры",
	"action.clear_unused_texture_space.desc": "Убрать с текстуры все пиксели, не использованные в UV-развёртке",
	"action.split_screen": "Разделить экран",
	"action.split_screen.desc": "Выбрать режим разделённого экрана для области просмотра",
	"action.split_screen.single": "Одинарный",
	"action.split_screen.double_horizontal": "Двойной горизонтальный",
	"action.split_screen.double_vertical": "Двойной вертикальный",
	"action.split_screen.quad": "Четверной",
	"action.split_screen.triple_left": "Тройной левый",
	"action.split_screen.triple_right": "Тройной правый",
	"action.split_screen.triple_top": "Тройной верхний",
	"action.split_screen.triple_bottom": "Тройной нижний",
	"action.uv_project_from_view": "Ракурсная UV-проекция",
	"action.uv_project_from_view.desc": "Автоматически генерировать UV-развёртку для выбранных граней с учётом 3D-перспективы",
	"action.graph_editor_other_graphs": "Показывать другие графы",
	"action.graph_editor_other_graphs.desc": "Отображать ли графы невыбранных осей",
	"action.graph_editor_include_other_graphs": "Включение сторонних графов",
	"action.graph_editor_include_other_graphs.desc": "Рассматривать ли невыбранные графы в графическом редакторе",
	"action.set_ik_source": "Установить ИК-корневую кость",
	"action.set_ik_source.desc": "Задать корневую кость, контролируемую нулевым объектом в инверсной кинематике",
	"edit.loop_cut.cuts": "Разрезы",
	"panel.element.stretch": "Растянуть",
	"preview_scene.minecraft_plains": "Равнины",
	"preview_scene.minecraft_cherry_grove": "Вишнёвая роща",
	"preview_scene.minecraft_snowy_tundra": "Снежная тундра",
	"preview_scene.minecraft_sunset": "Закат",
	"preview_scene.minecraft_night": "Ночь",
	"preview_scene.minecraft_desert": "Пустыня",
	"preview_scene.minecraft_underwater": "Под водой",
	"preview_scene.minecraft_coral_reef": "Коралловый риф",
	"preview_scene.minecraft_lush_cave": "Пышные пещеры",
	"preview_scene.minecraft_deep_dark": "Тёмные глубины",
	"generic.navigate_forward": "Вперёд",
	"generic.navigate_back": "Назад",
	"action.element_render_order": "Порядок отрисовки непрозрачности",
	"action.element_render_order.default": "Авто",
	"action.element_render_order.behind": "Позади",
	"action.element_render_order.in_front": "Спереди",
	"message.installing_update.title": "Доступно обновление",
	"message.installing_update.message": "Новая версия готова к установке. После закрытия приложения подожди около %0 секунд перед повторным запуском Blockbench или выключением компьютера, чтобы завершить установку обновления.",
	"settings.brush_cursor_2d": "2D-курсор кисти",
	"settings.brush_cursor_2d.desc": "Отображение контура вокруг кисти в 2D-пространстве",
	"settings.brush_cursor_3d": "3D-курсор кисти",
	"settings.brush_cursor_3d.desc": "Отображение контура вокруг кисти в 3D-пространстве",
	"settings.cdn_mirror": "Использовать зеркало CDN",
	"settings.cdn_mirror.desc": "Загружать плагины через зеркало CDN. Зеркало получает обновления раньше и работает в некоторых регионах, где основные серверы не работают.",
	"data.layer": "Слой",
	"data.panel": "Панель",
	"generic.confirm_delete": "Ты уверен, что хочешь удалить это?",
	"format_category.general": "Общее",
	"modifier_actions.no_uniform_scaling": "Свободное масштабирование",
	"message.texture_refresh_conflict.title": "Конфликт версий текстур",
	"message.texture_refresh_conflict.message": "Файл текстуры может содержать изменения, конфликтующие с версией Blockbench",
	"message.texture_refresh_conflict.keep_ours": "Сохранить версию Blockbench",
	"message.texture_refresh_conflict.keep_theirs": "Загрузить файл и отменить все изменения и слои в Blockbench",
	"message.group_required_to_animate": "Ты не можешь анимировать этот тип элемента. Создай группу для анимации.",
	"dialog.texture.uv_size": "Размер UV",
	"dialog.advanced_screenshot.angle_preset": "Шаблон ракурса",
	"dialog.advanced_screenshot.resolution": "Разрешение",
	"dialog.advanced_screenshot.zoom_to_fit": "Подогнать по размеру",
	"dialog.advanced_screenshot.zoom": "Приближение/фокусное расстояние",
	"dialog.advanced_screenshot.anti_aliasing": "Сглаживание",
	"dialog.advanced_screenshot.anti_aliasing.off": "Выключено",
	"dialog.advanced_screenshot.anti_aliasing.msaa": "MSAA",
	"dialog.advanced_screenshot.anti_aliasing.ssaa": "SSAA",
	"dialog.advanced_screenshot.show_gizmos": "Показать гизмо",
	"dialog.advanced_screenshot.shading": "Шэйдинг",
	"settings.auto_keyframe": "Автоматический ключевой кадр",
	"settings.auto_keyframe.desc": "Автоматически создавать ключевой кадр с начальными значениями при дальнейшем изменении кости на таймлайне",
	"settings.modded_entity_integer_size": "Целочисленный размер модовых сущностей",
	"settings.modded_entity_integer_size.desc": "Ограничить размеры кубов в формате модовых сущностей до целых чисел. Хотя в некоторых версиях поддерживаются дробные числа, целые числа гораздо проще использовать для UV-разметки.",
	"category.layers": "Слои",
	"keybind.paint_secondary_color": "Рисовать вторичным цветом",
	"action.selection_tool_operation_mode": "Режим операции с инструментом выделения",
	"action.selection_tool_operation_mode.create": "Новое выделение",
	"action.selection_tool_operation_mode.add": "Добавить к выделению",
	"action.selection_tool_operation_mode.subtract": "Вычесть из выделения",
	"action.selection_tool_operation_mode.intersect": "Пересечение",
	"action.pixel_perfect_drawing": "Плавное рисование",
	"action.pixel_perfect_drawing.desc": "Отрисовывать плавные пиксельные линии без интерполяции на изгибах",
	"action.selection_tool": "Инструмент выделения",
	"action.selection_tool.desc": "Выбирать части изображения",
	"action.selection_tool.rectangle": "Прямоугольник",
	"action.selection_tool.ellipse": "Эллипс",
	"action.selection_tool.lasso": "Лассо",
	"action.selection_tool.wand": "Волшебная палочка",
	"action.selection_tool.color": "Одинаковый цвет",
	"action.move_layer_tool": "Перемещение слоя",
	"action.move_layer_tool.desc": "Переместить текущий слой или выделение",
	"action.export_modded_animations": "Экспорт анимаций модовых сущностей",
	"action.export_modded_animations.desc": "Экспортировать анимации для модели модовой сущности Minecraft Java Edition",
	"action.swap_colors": "Поменять цвета",
	"action.swap_colors.desc": "Поменять основной цвет с вторичным",
	"action.apply_mesh_rotation": "Запечь вращения",
	"action.apply_mesh_rotation.desc": "Применить вращение к геометрии модели, убрав его из свойств элемента",
	"action.flip_texture_x.desc": "Отразить текстуру или слой по-горизонтали",
	"action.flip_texture_y.desc": "Отразить текстуру или слой по-вертикали",
	"action.rotate_texture_cw.desc": "Повернуть текстуру или слой по часовой стрелке",
	"action.rotate_texture_ccw.desc": "Повернуть текстуру или слой против часовой стрелки",
	"action.crop_texture_to_selection": "Обрезание текстуры по выделению",
	"action.create_empty_layer": "Создание слоя",
	"action.enable_texture_layers": "Включение слоёв",
	"action.disable_texture_layers": "Отключение слоёв",
	"action.layer_opacity": "Непрозрачность слоя",
	"action.layer_to_texture_size": "Раскрытие слоя",
	"action.layer_to_texture_size.desc": "Расширить слой до размера текстуры",
	"action.merge_layer_down": "Объединить с предыдущим",
	"action.merge_layer_down.desc": "Соединить выбранный слой с лежащим снизу",
	"action.advanced_screenshot": "Продвинутый снимок экрана...",
	"action.advanced_screenshot.desc": "Сделать снимок модели с расширенными опциями",
	"action.bake_ik_animation": "Запечь анимации обратной кинематики",
	"action.bake_ik_animation.desc": "Запечь вращения, применённые инверсной кинематикой, в выбранную анимацию",
	"action.save_animation_preset": "Сохранить шаблон анимации...",
	"action.save_animation_preset.desc": "Сохранить выбранные ключевые кадры как шаблон анимации",
	"action.animation_onion_skin": "Калькирование анимации",
	"action.animation_onion_skin.desc": "Отобразить каркасный вид иного кадра анимации в качестве референса для нынешнего",
	"action.apply_animation_preset": "Применение шаблон анимации",
	"action.apply_animation_preset.desc": "Выбрать из списка шаблонов анимации и применить к выбранной кости",
	"menu.brush_presets.pixel_perfect": "Плавное рисование",
	"panel.layers": "Слои",
	"uv_editor.copy_paste_tool.to_layer": "На новый слой",
	"format.image.new": "Создать новое изображение",
	"format.image.info.summary": "Встроенный фоторедактор позволяет создавать и редактировать изображения непосредственно в Blockbench, без необходимости использования внешнего графического редактора, например, для создания текстур.",
	"settings.move_with_selection_tool": "Перемещение выделений с помощью инструмента выделения",
	"settings.move_with_selection_tool.desc": "Позволяет инструменту выделения перемещать выделения напрямую, без необходимости переключаться на инструмент перемещения слоев",
	"settings.final_newline": "Конечный перенос",
	"settings.final_newline.desc": "Переносить строку в конце экспортируемых файлов",
	"action.crop_layer_to_selection": "Обрезание слоя по выделению",
	"action.edit_mode_uv_overlay.desc": "Показывать UV-карту поверх модели в режиме редактирования",
	"menu.image": "Изображение",
	"menu.texture.discard_changes": "Отменить изменения",
	"menu.texture.discard_changes.desc": "Отменить все несохранённые изменения и загрузить актуальную версию из файла",
	"panel.textures.images": "Изображения",
	"dialog.advanced": "Продвинутые",
	"dialog.recommended_option": "рекомендуется",
	"modifier_actions.snap_to_center": "Привязка к центру",
	"modifier_actions.snap_to_pixels": "Привязка к пикселям",
	"message.invalid_format.install_plugin": "Установить плагин %0",
	"message.plugin_deprecated.message": "Ты уверен, что хочешь установить этот устаревший плагин?",
	"message.plugin_deprecated.install_anyway": "Всё равно установить",
	"message.image_editor.not_found": "Не удалось найти выбранный фоторедактор.",
	"message.knife_tool.confirm": "Нажми %0 или нажми сюда, чтобы применить нож",
	"message.knife_tool.skipped_face": "Невозможно разрезать разные грани, не включив в сечение соединяющие их точки или рёбра",
	"message.optimize_animation.keyframes_removed": "Удалено %0 избыточных ключевых кадров",
	"message.optimize_animation.nothing_to_optimize": "Ничего не найдено для оптимизации!",
	"message.duplicate_bone_copy_animation.title": "Копировать анимацию",
	"message.duplicate_bone_copy_animation.message": "Дублированная кость анимируется в %0 анимациях. Ты хочешь скопировать ключевые кадры для новой кости?",
	"message.auto_fix_mesh_edit.title": "Автоисправление",
	"message.auto_fix_mesh_edit.revert": "Отменить редактирование",
	"message.auto_fix_mesh_edit.overlapping_vertices": "Несколько вершин было перемещено в одну точку. Что с ними сделать?",
	"message.auto_fix_mesh_edit.concave_quads": "Одна или несколько четырехугольных граней теперь вогнуты, что может вызвать проблемы при UV-развёртке и рендеринге. Blockbench может автоматически исправить это для тебя:",
	"message.auto_fix_mesh_edit.merge_vertices": "Объединить вершины",
	"message.auto_fix_mesh_edit.split_quads": "Разделить четырехугольники",
	"message.load_images.add_image": "Добавить изображение",
	"dialog.project.modded_entity_entity_class": "Класс сущности",
	"dialog.resize_texture.offset": "Смещение",
	"dialog.animated_texture_editor.code_reference": "Справочник кода",
	"dialog.animated_texture_editor.code_reference.about": "Этот код представлен в качестве примера и может нуждаться в корректировке. Ознакомься с документацией, чтобы узнать больше.",
	"dialog.animated_texture_editor.code_reference.docs": "Документация",
	"dialog.animated_texture_editor.reframe": "Изменить кадрирование",
	"dialog.animated_texture_editor.stride": "Размер кадра",
	"dialog.animated_texture_editor.frames": "Количество кадров",
	"dialog.animated_texture_editor.add_frame": "Добавить кадр",
	"dialog.animated_texture_editor.resize_frames": "Изменить размер кадров...",
	"dialog.animated_texture_editor.apply": "Применить",
	"dialog.add_primitive.edge_size": "Размер ребра",
	"dialog.change_animation_speed.speed": "Скорость",
	"dialog.change_animation_speed.adjust_snapping": "Регулировка привязки",
	"dialog.optimize_animation.selection": "Выбор",
	"dialog.optimize_animation.selection.selected_keyframes": "Выбранные ключевые кадры",
	"dialog.optimize_animation.selection.selected_animation": "Выбранная анимация",
	"dialog.optimize_animation.selection.all_animations": "Все анимации",
	"dialog.optimize_animation.thresholds": "Пороговые значения",
	"dialog.import_obj.obj": "Файл OBJ",
	"dialog.import_obj.mtl": "Файл MTL",
	"dialog.import_obj.scale": "Масштаб",
	"layout.thumbnail": "Пользовательский CSS для миниатюры",
	"settings.pixel_grid": "Пиксельная сетка",
	"settings.pixel_grid.desc": "Отображать пиксельную сетку текстуры на элементах в режиме редактирования",
	"settings.image_editor_grid_size": "Размер сетки в редакторе изображений",
	"settings.image_editor_grid_size.desc": "Размер большой сетки в 2D редакторе изображений",
	"settings.ground_plane_double_side": "Двусторонняя плоскость пола",
	"settings.ground_plane_double_side.desc": "Сделать плоскость пола видимой снизу",
	"settings.optifine_save_default_texture": "OptiFine JEM: Экспортировать выбранную текстуру",
	"settings.optifine_save_default_texture.desc": "Экспортировать выбранную текстуру как стандартную для модели",
	"action.slider_color_select_threshold": "Порог выбора цвета",
	"action.slider_color_select_threshold.desc": "Насколько близким должен быть цвет соседнего пикселя, чтобы он был выбран по цвету или волшебной палочкой",
	"action.stretch_tool": "Растягивание",
	"action.stretch_tool.desc": "Инструмент для выделения и растягивания элементов",
	"action.knife_tool": "Нож",
	"action.knife_tool.desc": "Инструмент для разрезания граней мэша на меньшие части",
	"action.duplicate_project": "Дублировать проект",
	"action.duplicate_project.desc": "Создать копию открытого проекта",
	"action.transform_space.parent": "Родитель",
	"action.transform_pivot_space": "Пространство трансформации оси",
	"action.solidify_mesh_selection": "Уплотнить грани",
	"action.solidify_mesh_selection.desc": "Уплотнить выбранные грани сетки",
	"action.animated_texture_editor": "Флипбук-анимация...",
	"action.animated_texture_editor.desc": "Настроить или изменить флипбук-анимацию для выбранной текстуры",
	"action.center_individual_pivots": "Центрирование индивидуальных осей",
	"action.center_individual_pivots.desc": "Установить точку поворота каждого выбранного элемента в его центр",
	"action.uv_cycle": "Цикл UV",
	"action.uv_cycle.desc": "Циклически менять порядок UV-вершин без изменения их положения",
	"action.uv_cycle_invert": "Инвертирование UV",
	"action.uv_cycle_invert.desc": "Обратить порядок расположения вершин на UV-развёртке, не изменяя фактического положения UV",
	"action.slider_animation_controller_speed": "Скорость воспроизведения контроллера",
	"action.slider_animation_controller_speed.desc": "Установить скорость воспроизведения анимационных контроллеров в процентах",
	"action.optimize_animation": "Оптимизировать анимацию",
	"action.optimize_animation.desc": "Уменьшить количество ключевых кадров, оптимизировав анимацию",
	"action.change_animation_speed": "Скорость анимации...",
	"action.change_animation_speed.desc": "Изменить скорость выбранной анимации",
	"timeline.select_particle_file": "Выбрать файл частиц",
	"timeline.select_sound_file": "Выбрать звуковой файл",
	"menu.cube.texture.default": "По умолчанию",
	"menu.texture.particle.clear": "Прекратить использование для частиц",
	"menu.texture.use_as_default": "Установить по умолчанию",
	"menu.texture.use_as_default.clear": "Отменить установку по умолчанию",
	"menu.toolbar.overflow": "Переполнение панели инструментов",
	"edit.solidify_mesh_selection.thickness": "Толщина",
	"reference_image.sync_to_timeline": "Синхронизация с временной шкалой",
	"reference_image.toggle_playback": "Воспроизведение/пауза",
	"dialog.add_primitive.shape.beveled_cuboid": "Округлый параллелепипед",
	"dialog.ignore_all": "Проигнорировать всё",
	"data.texture_group": "Группа текстур",
	"data.animation": "Анимация",
	"generic.on": "Вкл",
	"generic.off": "Выкл",
	"format.free.info.3d_printing": "3D-печать",
	"message.invalid_file.merge_conflict": "Файл содержит неразрешённый конфликт слияния в Git",
	"dialog.expand_texture_selection.radius": "Значение",
	"dialog.expand_texture_selection.corner": "Угловая форма",
	"dialog.expand_texture_selection.corner.round": "Круг",
	"dialog.expand_texture_selection.corner.square": "Квадрат",
	"dialog.expand_texture_selection.corner.manhattan": "Зеленоград",
	"dialog.merge_animation.merge_target": "Слить с...",
	"keybindings.variation_conflict": "Конфликт при привязке горячих клавиш",
	"settings.recovery_save_interval": "Автосохранение точки восстановления",
	"settings.recovery_save_interval.desc": "Изменить секундный интервал автосохранения Blockbench на случай компьютерных сбоев. Установи значение 0, чтобы отключить автосохранение.",
	"settings.save_view_per_tab": "Межвкладочный вид",
	"settings.save_view_per_tab.desc": "Сохранять угол обзора для каждой открытой вкладки",
	"settings.inherit_parent_color": "Использовать родительский цвет",
	"settings.inherit_parent_color.desc": "Устанавливать цвет маркёра нового элемента в родительский цвет вместо случайного",
	"keybind.preview_select.multi_select": "Мультивыделение",
	"keybind.preview_select.group_select": "Групповое выделение",
	"keybind.preview_select.loop_select": "Циклическое выделение",
	"action.fill_mode.selection": "Выделение",
	"action.fill_mode.selected_elements": "Выделенные элементы",
	"action.image_tiled_view": "Разделённый вид",
	"action.image_tiled_view.description": "Включить разделённый вид в 2D-редакторе",
	"action.image_onion_skin_view": "Калькирование",
	"action.image_onion_skin_view.description": "Включить калькирование в 2D-редакторе",
	"action.expand_texture_selection": "Расширить выделение текстуры",
	"action.expand_texture_selection.desc": "Увеличить или уменьшить область выделения текстуры",
	"action.switch_tabs.reverse_order": "Переключить вкладки в обратном порядке",
	"action.save_project_incremental": "Сохранить новую версию",
	"action.save_project_incremental.desc": "Сохранить текущую модель под новой версией (например, project_2.bbmodel вместо project.bbmodel)",
	"action.copy.multiple": "Копирование всего",
	"action.copy.multiple.desc": "Скопировать все доступные данные по отдельности",
	"action.paste.multiple": "Вставить всё",
	"action.randomize_marker_colors": "Рандомизация цветов-маркёров",
	"action.cube_light_emission": "Световая эмиссия",
	"action.cube_light_emission.desc": "Изменить уровень света выбранных элементов от 0 до 15",
	"action.view_mode.colored_solid": "Заливка цветом маркёра",
	"action.focus_on_selection.rotate_only": "Только вращение",
	"action.create_texture_group": "Создание группы текстур",
	"action.create_texture_group.desc": "Создать список из текстур, наследующих свойства группы",
	"action.uv_maximize.all_faces": "Применить ко всем граням",
	"action.retarget_animators": "Переназначить анимации",
	"action.retarget_animators.desc": "Выбрать, как будут управляться отдельные кости или элементы",
	"action.merge_animation": "Объединение анимаций",
	"action.merge_animation.desc": "Соединить анимацию с другой анимацией",
	"action.add_keyframe.reset_values": "Значения по умолчанию",
	"action.set_timeline_range_start": "Установить начало временной шкалы",
	"action.set_timeline_range_start.desc": "Установить начало воспроизведения на временной шкале",
	"action.set_timeline_range_end": "Установить конец временной шкалы",
	"action.set_timeline_range_end.desc": "Установить конец воспроизведения на временной шкале",
	"action.disable_timeline_range": "Отключение диапазона временной шкалы",
	"action.disable_timeline_range.desc": "Отключить настроенный диапазон воспроизведения на временной шкале",
	"menu.texture_group.resolve": "Разрешить",
	"menu.image_tiled_view.mirrored": "Зеркальные края",
	"menu.image_onion_skin_view.frame": "Кадры",
	"menu.image_onion_skin_view.frame.last_viewed": "Последний открытый кадр",
	"menu.image_onion_skin_view.frame.previous": "Предыдущий кадр",
	"menu.image_onion_skin_view.frame.next": "Следующий кадр",
	"menu.image_onion_skin_view.frame.both": "Предыдущий + следующий",
	"menu.image_onion_skin_view.display": "Отобразить",
	"menu.image_onion_skin_view.display.pixels": "Уменьшенные пикселы",
	"menu.image_onion_skin_view.display.transparent": "Прозрачность",
	"menu.image_onion_skin_view.above": "Отображать сверху",
	"menu.animation.reload": "Перезагрузить",
	"switches.autouv.alt": "Относительно",
	"display.rotation_pivot": "Ось вращения",
	"display.scale_pivot": "Ось масштаба",
	"display.reference.fox": "Лиса",
	"display.reference.eating": "Поедание",
	"preview_scene.sky": "Небо",
	"preview_scene.space": "Космос",
	"preview_scene.minecraft_ocean": "Океан",
	"message.import_palette.selection_only": "Только выделение",
	"dialog.blend_transition_edit.ease_in_out": "Ease-in-out (%0)",
	"dialog.blend_transition_edit.generate": "Сгенерировать...",
	"dialog.blend_transition_edit.generate.learn_more": "Больше информации",
	"dialog.blend_transition_edit.generate.curve": "Тип интерполяции",
	"dialog.blend_transition_edit.generate.steps": "Ключевые кадры",
	"settings.fps_limit": "Лимит FPS",
	"settings.fps_limit.desc": "Ограничить значение FPS, рендеримое Blockbench.",
	"settings.outliner_reveal_on_select": "Раскрыть элементы при выборе",
	"settings.outliner_reveal_on_select.desc": "Раскрывать выделенные элементы в списке",
	"settings.java_export_pivots": "Экспортировать значения вращений в модели для Minecraft JE",
	"settings.java_export_pivots.desc": "Сохранять точки вращения в моделях для Minecraft JE даже для непровёрнутых кубов",
	"animation_controllers.state.blend_transition_curve": "Кривая плавного перехода",
	"menu.slider.reset_vector": "Сбросить вектор",
	"dialog.blend_transition_edit.extended": "Расширенный граф анимаций",
	"message.screenshot_too_large.title": "Проблема с разрешением снимка",
	"message.screenshot_too_large.message": "Скриншот не может быть отрендерен правильно. Попробуй ещё раз с более низким разрешением или без SSAA.",
	"message.rename_elements.numbering": "Ты можешь использовать специальные символы для генерации последовательных чисел: % для получения индекса элемента в группе, $ для получения индекса в выделении.",
	"generic.edit_externally": "Внешнее редактирование",
	"message.settings_require_restart.title": "Требуется перезагрузка",
	"message.settings_require_restart.message": "Некоторые настройки будут применены только после повторного запуска программы",
	"message.settings_require_restart.restart_now": "Перезагрузить сейчас",
	"message.settings_require_restart.restart_later": "Перезагрузить позже",
	"message.classroom_mode.install_plugin": "В учебном режиме нельзя устанавливать плагины",
	"dialog.collection.export_path": "Экспорт пути",
	"dialog.collection.select_all": "Выделить всё",
	"dialog.collection.select_none": "Ничего не выделять",
	"dialog.collection.add_with_filter": "Добавить с фильтром",
	"dialog.collection.remove": "Убрать",
	"dialog.material_config.title": "Конфиг материала",
	"dialog.material_config.color_value": "Значение цвета",
	"dialog.material_config.mer": "Металличность-эмиссия-шероховатость",
	"dialog.material_config.mer_value": "Значение MER",
	"dialog.material_config.depth_type": "Тип глубины",
	"dialog.create_texture.disable_mirror_uv": "Отключить отзеркаливание UV",
	"dialog.create_texture.disable_mirror_uv.desc": "Отключить отзеркаливание UV в режиме зеркального моделирования, чтобы сохранить отдельные UV для каждой грани",
	"dialog.create_gif.turn.sync_to_anim_length": "Синхронизация с длиной анимации",
	"settings.category.controls": "Управление",
	"settings.classroom_mode": "Учебный режим",
	"settings.classroom_mode.desc": "Убирает ссылки на социальные сети и ограничивает часть функционала",
	"settings.antialiasing_bleed_fix": "Сглаживание без размытия",
	"settings.antialiasing_bleed_fix.desc": "Не размывать текстуры во время сглаживания",
	"settings.tone_mapping": "Тональная обработка",
	"settings.tone_mapping.desc": "Метод для корректного отображения ярких и тёмных областей изображения на экранах с ограниченным диапазоном яркости.",
	"settings.audio_scrubbing": "Звук при прокрутке",
	"settings.audio_scrubbing.desc": "Проигрывать короткий отрывок аудио при прокручивании временной шкалы",
	"settings.viewport_rotate_speed": "Скорость вращения вьюпорта",
	"settings.viewport_rotate_speed.desc": "Изменить чувствительность при проворачивании вьюпорта",
	"settings.viewport_zoom_speed": "Скорость приближения вьюпорта",
	"settings.viewport_zoom_speed.desc": "Изменить чувствительность при приближении вьюпорта",
	"settings.editor_2d_zoom_speed": "Скорость приближения 2D-редактора",
	"settings.editor_2d_zoom_speed.desc": "Изменить чувствительность при приближении в 2D-редакторе",
	"category.select": "Выделение",
	"action.vertex_snap_mode.rotate": "Поворот",
	"action.export_image": "Экспорт изображения",
	"action.export_image.desc": "Экспортировать текстуру в файл изображения",
	"action.apply_mirror_modeling": "Применение зеркального моделирования",
	"action.apply_mirror_modeling.desc": "Применить зеркального моделирования к выделению. Все выбранные элементы будут копированы и повёрнуты по оси X",
	"action.create_collection": "Создание коллекции",
	"action.create_collection.desc": "Создать коллекцию из выбранных элементов из списка",
	"action.set_collection_content_to_selection": "Выделение содержимого коллекции",
	"action.set_collection_content_to_selection.desc": "Установить выбранные группы и элементы содержимым коллекции",
	"action.add_to_collection": "Добавление выбранного в коллекцию",
	"action.add_to_collection.desc": "Добавить выделенные группы и элементы в коллекцию",
	"action.view_mode.material": "Предпросмотр материала",
	"action.create_material": "Создание материала",
	"action.create_material.desc": "Создать новый PBR-материал из выбранной текстуры",
	"action.generate_pbr_map": "Генерация PBR-карты...",
	"action.generate_pbr_map.desc": "Сгенерировать PBR-карту (металличность, эмиссия, шероховатость и высоты) из существующей текстуры",
	"menu.tools.main_tools": "Инструментарий",
	"menu.view.panels": "Панели",
	"menu.texture.pbr_channel": "PBR-канал",
	"menu.texture.pbr_channel.color": "Цвет",
	"menu.texture.pbr_channel.normal": "Нормаль",
	"menu.texture.pbr_channel.height": "Высота",
	"menu.texture.pbr_channel.mer": "MER (Металличность-эмиссия-шероховатость)",
	"menu.texture.pbr_channel.mer_subsurface": "MER-подповерхность",
	"menu.collection.export_project": "Экспортировать проект",
	"menu.collection.export_as": "Экспортировать как %0",
	"menu.panel.enable": "Включить",
	"menu.panel.move_to": "Переместить в",
	"menu.panel.move_to.left_bar": "Левая боковая панель",
	"menu.panel.move_to.right_bar": "Правая боковая панель",
	"menu.panel.move_to.top": "Верх",
	"menu.panel.move_to.bottom": "Низ",
	"menu.panel.move_to.float": "Плавание",
	"menu.panel.move_to.hidden": "Спрятать",
	"menu.panel.fold": "Свернуть",
	"menu.mirror_painting.texture_center": "Центр текстуры",
	"menu.mirror_modeling.mirror_uv": "Отзеркаливание UV",
	"menu.animation_onion_skin.frames": "Кадры",
	"menu.animation_onion_skin.select": "Выделение",
	"menu.animation_onion_skin.previous": "Предыдущее",
	"menu.animation_onion_skin.next": "Следующее",
	"menu.animation_onion_skin.previous_next": "Предыдущее + следующее",
	"menu.animation_onion_skin.count": "Счёт",
	"menu.animation_onion_skin.interval": "Интервал",
	"menu.animation_onion_skin_selective": "Выборочное калькирование",
	"menu.animation_onion_skin_selective.desc": "Отображать кальку только для выбранной части модели",
	"edit.loop_cut.unit": "Единица",
	"edit.loop_cut.unit.size_units": "Единицы измерения размера",
	"edit.loop_cut.unit.percent": "Процент",
	"edit.extrude_mesh_selection.direction": "Направление",
	"edit.extrude_mesh_selection.direction.outwards": "Внешняя сторона",
	"edit.extrude_mesh_selection.direction.average": "Среднее",
	"edit.extrude_mesh_selection.even_extend": "Равномерное расширение",
	"edit.vertex_snap.align": "Выравнивание элементов",
	"edit.vertex_snap.align.longest": "По длиннейшей оси",
	"edit.vertex_snap.align.direction": "По направлению от центра поворота",
	"edit.vertex_snap.align.align_axis": "По оси %0",
	"edit.vertex_snap.ignore_axis": "Игнорирование оси",
	"codec.common.format": "Формат",
	"codec.image.quality": "Качество",
	"panel.collections": "Коллекции",
	"modifier_actions.always": "Всегда включено",
	"modifier_actions.unless": "Если не %0",
	"settings.undo_selections": "Отменить выделение",
	"settings.undo_selections.desc": "Фиксировать выделение в истории действий",
	"action.focus_on_selection.zoom": "Приближение к выбранному объекту",
	"display.reference.tooting": "Трубление в рог",
	"settings.selection_tolerance": "Допуск выделения",
	"settings.selection_tolerance.desc": "Размер области, по которой можно нажать, чтобы выбрать ребро или вершину",
	"action.delete.keep_vertices": "Сохранить рёбра/вершины",
	"menu.mesh": "Мэш",
	"dialog.material_config.subsurface": "Подповерхностное рассяние",
	"dialog.material_config.subsurface_enabled.desc": "Используйте альфа-канал карты MER для изучения подповерхностного рассеяния",
	"settings.pick_combined_color": "Выбрать смешанный цвет",
	"settings.pick_combined_color.desc": "Выберите комбинированный цвет всех слоёв в соответствующем пикселе вместо цвета активного слоя",
	"action.split_rgb_into_layers": "Разделить RGB каналы на слои",
	"action.split_rgb_into_layers.desc": "Разделите текстуру на аддитивные слои, по одному для каждого канала RGB",
	"dialog.project.java_block_version": "Версия формата",
	"data.spline_mesh": "Spline",
	"data.billboard": "Billboard",
	"data.armature": "Armature",
	"data.armature_bone": "Кость арматуры",
	"generic.reload": "Reload",
	"modifier_actions.subtract": "Subtract",
	"modifier_actions.reduced_intensity": "Fine-Tune",
	"modifier_actions.select_bone": "Выбрать кость",
	"modifier_actions.spline_select_multiple_points": "Select multiple Points or Handles",
	"modifier_actions.move_panel_without_docking": "Move without docking",
	"message.save_all_textures.message": "Do you want to save each of the following textures?",
	"message.save_all_textures.skip": "Skip",
	"dialog.add_spline.shape": "Shape",
	"dialog.add_spline.shape.segment": "Segment",
	"dialog.add_spline.shape.square": "Rectangle",
	"dialog.add_spline.shape.circle": "Circle",
	"dialog.add_spline.diameter": "Diameter",
	"dialog.add_spline.sides_tubular": "Tube Segments",
	"dialog.add_spline.sides_radial": "Ring Segments",
	"dialog.add_spline.radius": "Tube Radius",
	"dialog.add_spline.length": "Length",
	"dialog.add_spline.width": "Width",
	"dialog.plugins.revoke_permissions": "Revoke Permissions",
	"dialog.expression_editor.pretty_print": "Pretty Print",
	"dialog.expression_editor.minify": "Minify",
	"dialog.expression_editor.find_replace": "Find/Replace",
	"dialog.create_gif.show_gizmos": "Record Gizmos & Grid",
	"dialog.preview_options.title": "Preview Options",
	"dialog.preview_options.background": "Background",
	"dialog.preview_options.background.checkerboard": "Checkerboard",
	"dialog.preview_options.background.solid": "Solid",
	"dialog.preview_options.background.custom_color": "Custom Color",
	"dialog.preview_options.show_gizmos": "Show Gizmos",
	"dialog.skin.texture_source": "Texture Source",
	"dialog.skin.texture_source.template": "Generate Template",
	"dialog.skin.texture_source.load_texture": "Load from Minecraft",
	"dialog.skin.texture_file": "Texture File",
	"dialog.convert_skin.adjust_texture": "Adjust Texture",
	"dialog.settings.clear_profile_value": "Clear profile value",
	"layout.section.customize": "Customize",
	"layout.theme.configure": "Configure",
	"layout.color.elevated": "Elevated",
	"layout.color.elevated.desc": "Elevated UI elements, usually separated by drop shadow",
	"layout.file.watch_changes": "Watch Changes and Reload",
	"settings.autocomplete_code": "Autocomplete Code",
	"settings.autocomplete_code.desc": "Display autocomplete suggestions in code editors",
	"settings.detect_flipbook_textures": "Detect Flipbook Textures",
	"settings.detect_flipbook_textures.desc": "Automatically detect flipbook animated textures and preview them as animation",
	"settings.double_click_select_reference": "Select Reference Image on Double Click",
	"settings.double_click_select_reference.desc": "Double click the viewport to select a reference image",
	"settings.default_keyframe_interpolation": "Default Keyframe Interpolation",
	"settings.default_keyframe_interpolation.desc": "Select the default keyframe interpolation mode",
	"settings.color_picker_style": "Color Picker Style",
	"settings.color_picker_style.desc": "Select the style of the paint mode color picker",
	"settings.export_asset_paths": "Export Asset Paths",
	"settings.export_asset_paths.desc": "Select how paths to assets such as textures or animations get saved in .bbmodel files",
	"settings.export_asset_paths.relative": "Relative Paths",
	"settings.export_asset_paths.absolute": "Full Paths",
	"settings.export_asset_paths.both": "Relative & Full Paths (Texture only)",
	"settings.export_asset_paths.none": "No Export",
	"action.slider_spline_resolution": "Spline Resolution %0",
	"action.slider_spline_resolution.desc": "Change spline resolution on the %0 axis (%1)",
	"action.slider_spline_resolution.u.desc_precision": "Ring Segments",
	"action.slider_spline_resolution.v.desc_precision": "Tube Segments",
	"action.slider_spline_radius": "Spline Radius",
	"action.slider_spline_radius.desc": "Change spline Radius",
	"action.slider_spline_handle_tilt": "Handle Tilt",
	"action.slider_spline_handle_tilt.desc": "Change spline handle Tilt",
	"action.slider_spline_handle_size": "Handle Size",
	"action.slider_spline_handle_size.desc": "Change spline handle Size",
	"action.blend_mode.lighten": "Lighten",
	"action.blend_mode.darken": "Darken",
	"action.weight_brush": "Кисть весов",
	"action.weight_brush.desc": "Нарисуйте веса вершин на сетках для определения деформаций арматуры",
	"action.convert_minecraft_skin_variant": "Convert Slim/Wide Skin",
	"action.convert_minecraft_skin_variant.desc": "Switch the skin model between the classic wide (steve) model and the slim (alex) model. Optionally auto-adjust the texture to fit the model",
	"action.custom_skin_poses": "Custom Skin Poses",
	"action.custom_skin_poses.desc": "Load a custom skin pose preset",
	"action.custom_skin_poses.update": "Update Pose",
	"action.custom_skin_poses.update.desc": "Overwrite the saved pose with the current pose of the model",
	"action.add_custom_skin_pose": "Add Custom Skin Pose",
	"action.add_custom_skin_pose.desc": "Save the current pose of the model as a pose preset",
	"action.export_stl": "Export STL",
	"action.export_stl.desc": "Export a STL model for 3D printing",
	"action.add_element": "Add Element",
	"action.add_element.desc": "Add a new element from the list of element types",
	"action.add_spline": "Add Spline",
	"action.add_spline.desc": "Adds a new spline",
	"action.add_billboard": "Add Billboard",
	"action.add_billboard.desc": "Adds a new billboard, a flat element that always faces towards the camera",
	"action.add_armature": "Add Armature",
	"action.add_armature.desc": "Adds an armature that allows deforming a mesh via animation",
	"action.add_armature_bone": "Добавить кость к арматуре",
	"action.add_armature_bone.desc": "Adds a bone to the armature",
	"action.search_textures": "Search Textures",
	"action.search_textures.desc": "Search for textures by name",
	"action.search_animations": "Search Animations",
	"action.search_animations.desc": "Search for animations by name",
	"action.spline_selection_mode": "Spline Selection Mode",
	"action.spline_selection_mode.object": "Object",
	"action.spline_selection_mode.handles": "Handles",
	"action.spline_render_mode": "Geometry",
	"action.spline_render_mode.mesh": "Mesh",
	"action.spline_render_mode.path": "Path",
	"action.spline_render_mode.desc": "Which geometry this spline should render",
	"action.spline_uv_mode": "UV Style",
	"action.spline_uv_mode.length_accurate": "Length Accurate",
	"action.spline_uv_mode.uniform": "Uniform",
	"action.spline_uv_mode.per_segment": "Per Segment",
	"action.spline_uv_mode.desc": "How the spline's tube mesh should lay its UVs",
	"action.spline_ring_segments": "Ring Segments",
	"action.spline_ring_segments.desc": "How many subdivisions this Spline has per Tube Ring",
	"action.spline_tube_segments": "Tube Segments",
	"action.spline_tube_segments.desc": "How many subdivisions this Spline has along its path",
	"action.spline_tube_radius": "Tube Radius",
	"action.spline_tube_radius.desc": "Set the Spline's Tube Radius",
	"action.spline_display_space": "Display Space",
	"action.spline_display_space.desc": "Display spline space indicators on its path",
	"action.spline_handle_mode": "Spline Handle Mode",
	"action.spline_handle_mode.desc": "Which mode to use for transforming spline handles",
	"action.spline_handle_mode.aligned": "Aligned",
	"action.spline_handle_mode.free": "Free",
	"action.spline_handle_mode.mirrored": "Mirrored",
	"action.slider_weight_brush_size": "Размер весовой кисти",
	"action.weight_brush_xray": "Сила кисти рентгеновского режима",
	"action.weight_brush_xray.desc": "Когда включено, весовая кисть будет влиять на все вершины, вместо тех что видны на поверхности",
	"action.apply_spline_rotation": "Apply Rotation",
	"action.apply_spline_rotation.desc": "Reset the element rotation of the spline, and apply it to the geometry instead",
	"action.extrude_spline_selection": "Extrude Spline",
	"action.extrude_spline_selection.desc": "Extrude the selected handle on all splines",
	"action.split_spline": "Split Spline",
	"action.split_spline.desc": "Splits the spline into two splines at the selected handle",
	"action.divide_spline_curve": "Divide Spline Segment",
	"action.divide_spline_curve.desc": "Splits the spline segment into two new segments with a new handle at their intersection",
	"action.set_vertex_weights": "Установить веса вершин",
	"action.set_vertex_weights.desc": "Установить вес вершины выбранной вершины то определённого значения кости арматуры",
	"action.calculate_vertex_weights": "Вычислить веса вершин",
	"action.calculate_vertex_weights.desc": "Автоматически применить весы вершин базированные на положении костей",
	"action.shelf_alignment": "Shelf Alignment",
	"action.shelf_alignment.desc": "Select the vertical alignment of items on the shelf",
	"action.shelf_alignment.top": "Top Alignment",
	"action.shelf_alignment.bottom": "Bottom Alignment",
	"action.view_mode.vertex_weight": "Вес вершины",
	"action.view_mode.weighted_bone_colors": "Цвет вершины кости",
	"action.create_animation_group": "Create Animation Group",
	"action.create_animation_group.desc": "Create a group of animations",
	"action.move_graph_keyframes_up": "Move Keyframe Graph Up",
	"action.move_graph_keyframes_down": "Move Keyframe Graph Down",
	"menu.skin": "Skin",
	"menu.text_edit.expression_editor": "Expression Editor",
	"menu.color_picker.picker_type.normal": "Normal Map",
	"menu.texture.flipbook_animation": "Flipbook Animation",
	"menu.panel.attach_to": "Attach To",
	"menu.animation.playing": "Playing",
	"menu.animation_file.save_as": "Save As",
	"menu.animator.quaternion_interpolation": "Quaternion Interpolation",
	"edit.extrude_spline_selection.extend": "Extend",
	"edit.divide_spline_curve.position": "Position",
	"group.bedrock_binding": "Binding",
	"group.cem_attach": "CEM Attach",
	"group.cem_model": "CEM Model",
	"group.cem_scale": "CEM Scale",
	"cube.rescale": "Rotation Rescale",
	"cube.rescale.desc": "Rescale cube to compensate for the rotation angle",
	"mesh.shading": "Shading",
	"mesh.shading.flat": "Flat",
	"mesh.shading.smooth": "Smooth",
	"spline_mesh.cyclic": "Cyclic",
	"spline_mesh.cyclic.desc": "Whether the selected spline should form a loop (Cycle)",
	"billboard.offset": "Offset",
	"billboard.facing_mode": "Facing Mode",
	"billboard.facing_mode.lookat": "Look At",
	"billboard.facing_mode.lookat_y": "Look At Y",
	"billboard.facing_mode.rotate": "Rotate",
	"billboard.facing_mode.rotate_y": "Rotate Y",
	"armature_bone.connected": "Соединённы",
	"reference_image.blueprint": "Locked Blueprint",
	"codec.image.alpha_channel": "Alpha Channel",
	"codec.image.animation_fps": "Animation FPS",
	"panel.palette": "Palette",
	"panel.keyframe.change_effect_file": "Change Effect File",
	"panel.transform": "Transform",
	"panel.element.spline_dimensions": "Spline Dimensions",
	"display.slot.on_shelf": "Shelf",
	"display.reference.shelf": "Shelf (All Slots)",
	"display.reference.shelf_left": "Shelf (Left Slot)",
	"display.reference.shelf_center": "Shelf (Center Slot)",
	"display.reference.shelf_right": "Shelf (Right Slot)",
	"message.newer_project_format_version.title": "Outdated client",
	"message.newer_project_format_version.message": "This file was saved in a newer version of Blockbench. Update to Blockbench %0 or newer to be able to open it correctly",
	"message.load_images.add_layer": "Add as Layer",
	"message.load_images.category.add_to_project": "Add to project",
	"message.load_images.category.new_project": "New project",
	"message.load_palette.title": "Load Palette",
	"message.load_palette.message": "Are you sure you want to load this palette? This will replace your current color palette.",
	"dialog.set_vertex_weights.weight": "Веса",
	"dialog.set_vertex_weights.overwrite": "Переписать другие кости",
	"action.element_render_order.short": "Render Order",
	"action.element_render_order.desc": "Render order of elements. This can help fix elements that are hidden behind other elements with transparent textures. Leave it on Auto for opaque elements.",
	"spline.shading.flat": "Flat",
	"spline.shading.smooth": "Smooth",
	"spline.shading": "Shading",
	"spline.shading.desc": "How this spline's tube should be shaded",
	"action.slider_weight_brush_limit": "Лимит весовой кисти",
	"action.slider_weight_brush_limit.desc": "Set an upper limit for how much weight the weight brush can assign to a vertex",
	"action.weight_brush_blend_mode": "Weight Brush Blend Mode",
	"action.weight_brush_blend_mode.set": "Set",
	"action.weight_brush_blend_mode.add": "Add",
	"action.apply_texture_to_elements": "Apply Texture to Elements",
	"action.apply_texture_to_elements.desc": "Apply the selected texture to the selected elements",
	"menu.panel.reset_size": "Reset Size",
	"action.import_layer": "Import Layer",
	"action.import_layer.desc": "Import image files as layers",
	"menu.collection.open_file": "Open File",
	"layout.version": "Version",
	"settings.status_bar_transform_sliders": "Transform Sliders in Status Bar",
	"settings.status_bar_transform_sliders.desc": "Display the transform sliders toolbar of the selected tool in the status bar instead of using the Transform panel",
	"settings.default_bedrock_format": "Default Bedrock Format",
	"settings.default_bedrock_format.desc": "Select the default format to load Minecraft Bedrock models in, when no specific format can be detected from context.",
	"settings.limit_brush_opacity_per_stroke": "Limit Brush Opacity per Stroke",
	"settings.limit_brush_opacity_per_stroke.desc": "Limit the opacity that a brush can apply to the value of the opacity slider during each brush stroke. With a smooth brush this behavior can potentially lead to slight unwanted noise.",
	"action.merge_splines": "Merge Splines",
	"action.merge_splines.desc": "Merge multiple splines into one",
	"settings.default_java_block_version": "Default Java Block/Item Version",
	"settings.default_java_block_version.desc": "Default format version when creating new Java block/item models or opening files without format version",
	"data.bounding_box": "Bounding Box",
	"keys.option": "Option",
	"keys.slide_lmb_horizontal": "Left-click slide horizontal",
	"keys.slide_lmb_vertical": "Left-click slide vertical",
	"keys.slide_rmb_horizontal": "Right-click slide horizontal",
	"keys.slide_rmb_vertical": "Right-click slide vertical",
	"message.recover_backup.unknown_project": "Unknown project",
	"message.recover_backup.discard_others": "Discard all others",
	"message.unsupported_file_extension.title": "File format not supported",
	"message.unsupported_file_extension.message": "Cannot open file %0, the format is not supported. You might need a plugin for this file type.",
	"message.unsupported_file_extension.open_in_default_program": "Open in default program",
	"dialog.project.uv_size": "UV Size",
	"dialog.collection.offset": "Offset",
	"dialog.texture.fps": "FPS",
	"dialog.texture.fps.desc": "Frames per second of the texture flipbook animation",
	"dialog.edit_uv_size.title": "Edit UV Size",
	"dialog.edit_uv_size.target": "Target",
	"dialog.edit_uv_size.adjust": "Adjust",
	"dialog.edit_uv_size.adjust.adjust_uv": "Counter UV",
	"dialog.edit_uv_size.adjust.adjust_scale": "Counter UV & Scale",
	"dialog.edit_uv_size.adjust.keep": "Keep UV",
	"dialog.edit_uv_size.target_size": "Target UV Size",
	"dialog.edit_uv_size.preset.original": "Original",
	"dialog.edit_uv_size.preset.match_texture": "Match Texture",
	"dialog.edit_uv_size.result": "Result",
	"dialog.edit_uv_size.result.textures": "Textures",
	"dialog.adjust_brightness_contrast.brightness": "Brightness",
	"dialog.adjust_brightness_contrast.contrast": "Contrast",
	"dialog.adjust_saturation_hue.saturation": "Saturation",
	"dialog.adjust_saturation_hue.hue": "Hue",
	"dialog.adjust_opacity.mode": "Mode",
	"dialog.adjust_opacity.mode.multiply": "Multiply",
	"dialog.adjust_opacity.mode.set": "Set",
	"dialog.bedrock_bounding_box.type": "Type",
	"dialog.bedrock_bounding_box.type.collision_box": "Collision",
	"dialog.bedrock_bounding_box.type.selection_box": "Selection Box",
	"dialog.bedrock_bounding_box.type.hitbox": "Hitbox",
	"dialog.bedrock_bounding_box.hitbox_note": "Please note that entity hitboxes only work up to a certain size and may not adapt to the rotation of the entity in-game.",
	"dialog.bedrock_bounding_box.collision_note": "Please note that entity collision boxes only support one centered shape with a square top profile.",
	"dialog.bedrock_bounding_box.no_bounding_boxes": "No bounding boxes exist in this project",
	"dialog.install_plugins_from_list.ids": "Plugin IDs",
	"dialog.install_plugins_from_list.info": "Install several plugins from a list of IDs. Before installing, please ensure that you actually need all plugins. Keeping inactive plugins can increase the risk of bugs and incompatibilities with future updates.",
	"dialog.copy_installed_plugins.details": "Include Details",
	"dialog.flip_animation.phase_offset": "Phase Offset",
	"dialog.flip_animation.phase_offset.off": "Off",
	"dialog.flip_animation.phase_offset.custom": "Custom",
	"dialog.flip_animation.clear_opposite": "Overwrite opposite",
	"settings.flipbook_textures_in_animation": "Play Flipbook Textures in Animation",
	"settings.flipbook_textures_in_animation.desc": "Preview animations on flipbook textures in sync with the animation timeline",
	"settings.display_uv": "Display UV Faces",
	"settings.display_uv.desc": "Select which UV faces are displayed in the UV editor",
	"settings.display_uv.selected_faces": "Only selected faces",
	"settings.display_uv.selected_elements": "All faces on selected elements",
	"settings.display_uv.all_elements": "All faces on all elements",
	"settings.local_position_values": "Local Position Values",
	"settings.local_position_values.desc": "Display all position values in the Transform panel in local space",
	"settings.transform_cube_from_center": "Transform Cubes from Center",
	"settings.transform_cube_from_center.desc": "Edit the cube position values from the center instead of the corner",
	"settings.color_picker_tool_switch": "Color Picker Tool Switch",
	"settings.color_picker_tool_switch.desc": "When picking a transparent pixel, switch to the eraser. When the eraser was previously selected and a color is picked, switch to the brush",
	"keybind.preview_scroll_zoom": "Zoom View",
	"keybind.uv_editor_scroll_zoom": "Zoom UV/2D Editor",
	"action.blend_mode.alpha_mask": "Alpha Mask",
	"action.swap_tools.hold": "Hold to swap (Color Picker)",
	"action.import_bedrock_voxel_shape": "Import Bedrock Voxel Shape",
	"action.import_bedrock_voxel_shape.desc": "Add a voxel shape from a json file to the current project",
	"action.export_bedrock_voxel_shape": "Export Bedrock Voxel Shape",
	"action.export_bedrock_voxel_shape.desc": "Export the bounding boxes in the project as a bedrock voxel shape file",
	"action.plugins_window_menu": "Menu",
	"action.copy_installed_plugins": "Copy Installed Plugins",
	"action.copy_installed_plugins.desc": "Generate and copy a list of the currently installed plugins",
	"action.install_plugins_from_list": "Install Plugins from List",
	"action.install_plugins_from_list.desc": "Install plugins from a list of plugin IDs",
	"action.add_bounding_box": "Add Bounding Box",
	"action.add_bounding_box.desc": "Adds a new bounding box",
	"action.split_alpha_into_layer": "Split Alpha Channel into Layer",
	"action.split_alpha_into_layer.desc": "Split the alpha channel of the texture into an alpha mask layer",
	"action.generate_bedrock_block_box": "Copy Collision/Selection Component",
	"action.generate_bedrock_block_box.desc": "Generate a collision or selection box component for Minecraft Bedrock Edition blocks",
	"action.generate_bedrock_entity_box": "Copy Collision/Hitbox Component",
	"action.generate_bedrock_entity_box.desc": "Generate a collision or custom hit test component for Minecraft Bedrock Edition entities",
	"action.refresh_texture": "Refresh Texture",
	"action.refresh_texture.desc": "Reload the texture from file",
	"action.move_uv_to_cursor": "Move UV to Cursor",
	"action.move_uv_to_cursor.desc": "Move the selected UV faces to the mouse cursor position",
	"action.edit_mode_uv_overlay": "Display All Elements",
	"action.round_keyframe_values": "Round Keyframe Values",
	"action.round_keyframe_values.desc": "Round all values of the selected keyframes",
	"action.keyframe_column_create.all_channels": "All Channels",
	"action.keyframe_column_create.all_channels.desc": "Initialize all channels with keyframes even if they had no keyframes previously",
	"action.add_all_to_timeline": "Add All to Timeline",
	"action.mirror_animating": "Mirror Animating",
	"action.mirror_animating.desc": "Mirror animation edits to the opposite side",
	"action.copy_animation_pose": "Copy Animation Pose",
	"action.copy_animation_pose.desc": "Copy all keyframes to replicate the current animation pose",
	"menu.texture.file_format": "File Format",
	"menu.texture.wrap_mode": "Wrap Mode",
	"menu.texture.wrap_mode.limited": "Restricted",
	"menu.texture.wrap_mode.repeat": "Repeat",
	"menu.texture.wrap_mode.clamp": "Clamp Edge",
	"edit.reparent_selection.adjust_position": "Preserve World Transform",
	"texture_mesh.texture_name": "Texture Name",
	"display.slot.embedded": "Embedded",
	"display.animate_preview": "Preview Animation",
	"display.reference.flower_pot": "Flower Pot"
}